"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5071,4892,3439],{

/***/ 38562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12971);
/* harmony import */ var utils_firebase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18945);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
 // import getConfig from "next/config";







var ElectionsWidget = function ElectionsWidget() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    electionExitPollToggle: false,
    electionResultToggle: true,
    vidhansabhaResultToggle: true,
    resultVersion: 1.6,
    exitPollVersion: 1.2,
    electionYear: 2024,
    isElectionAlpha: true,
    keyCandidate: true
  }),
      publicRuntimeConfig = _useState[0],
      setPublicRunTimeConfig = _useState[1]; // const { publicRuntimeConfig } = getConfig();


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      lokExit = _useState2[0],
      setLokExit = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (true) {
      var remoteConfig = (0,firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__/* .getRemoteConfig */ .sN)(utils_firebase__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
      remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
      (0,firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__/* .fetchAndActivate */ .xS)(remoteConfig).then(function () {
        var titleData = (0,firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__/* .getString */ .KF)(remoteConfig, "electionKeys");
        var parsedData = JSON.parse(titleData);
        setPublicRunTimeConfig(parsedData); // console.log("Election Keys are ", (parsedData))
        // setVideoUrl(titleData);
      })["catch"](function (err) {
        console.error(err);
      });
    }
  }, []); // console.log(
  //   "ElectionWidges are",
  //   publicRuntimeConfig?.electionExitPollToggle
  // );

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: (publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.electionExitPollToggle) === true && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "election-result-tally",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
        style: {
          paddingLeft: "10px",
          fontWeight: "700",
          fontSize: "22px",
          paddingTop: "10px",
          paddingBottom: "5px",
          background: "white"
        },
        children: "\u090F\u0917\u094D\u091C\u093F\u091F \u092A\u094B\u0932"
      }), lokExit ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("iframe", {
        width: "100%",
        height: "370px",
        scrolling: "no" // src= "https://electionresults.intoday.in/elections/2024/loksabha-elections/html/exit-poll/lok-sabha-exit-poll.html?site=lallantop&theme=1&v=1.0"
        ,
        src: "https://electionresults.intoday.in/elections/2024/loksabha-elections/html/loksabhastate-exitpoll/lok-sabha-exit-poll.html?site=lallantop&theme=1&v=5.0"
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("iframe", {
        width: "100%",
        height: "340px",
        scrolling: "no",
        src: "https://electionresults.intoday.in/elections/2024/assembly-elections/html/exit-poll/assembly-exit-poll.html?site=lallantop&device=web&v=5.1"
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ElectionsWidget);

/***/ }),

/***/ 74892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var FAQComponent = function FAQComponent(_ref) {
  var data = _ref.data,
      title = _ref.title,
      _ref$removeHeading = _ref.removeHeading,
      removeHeading = _ref$removeHeading === void 0 ? false : _ref$removeHeading;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var toggleAnswer = function toggleAnswer(index) {
    setActiveIndex(activeIndex === index ? null : index);
  };

  var faqs = data && data.length > 0 ? data : [];
  console.log("TITLE is ", title);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [faqs.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "faq-parent",
      children: [removeHeading === false && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h2", {
        className: "faq-title",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
          src: "/assets/images/faq-icon.png",
          width: "24px",
          height: "24px"
        }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          id: "FAQ"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "faq-container",
        children: faqs.map(function (faq, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "faq-item",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
              onClick: function onClick() {
                return toggleAnswer(index);
              },
              className: "faq-question",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h2", {
                style: {
                  fontSize: "20px"
                },
                children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                  children: faq.question
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                style: {
                  alignContent: "center",
                  cursor: "pointer"
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                  src: "/assets/images/".concat(activeIndex === index ? "minus" : "add", "-square.png"),
                  width: "24px",
                  height: "24px"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "faq-answer ".concat(activeIndex === index ? "show" : ""),
                children: faq.answer
              })
            })]
          }, index);
        })
      })]
    }), faqs.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
      id: "my-script2",
      type: "application/ld+json",
      strategy: "afterInteractive",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs === null || faqs === void 0 ? void 0 : faqs.map(function (x) {
            return {
              "@type": "Question",
              name: x.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: x.answer
              }
            };
          })
        })
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (FAQComponent);

/***/ }),

/***/ 45071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(16835);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(27812);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(15763);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(44012);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2185);
/* harmony import */ var api_apiInstance__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85503);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96781);
/* harmony import */ var api_constants__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(9041);
/* harmony import */ var constants_cardsConstant__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97208);
/* harmony import */ var constants_loginConstants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56036);
/* harmony import */ var hooks_useInViewport__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69502);
/* harmony import */ var localization_i8intl__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(54269);
/* harmony import */ var redux_actions_ads_Actions__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(8969);
/* harmony import */ var redux_actions_bookmarksActions__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(73295);
/* harmony import */ var redux_actions_postAction__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(25609);
/* harmony import */ var utils_deviceIdGenerator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(32710);
/* harmony import */ var utils_encryption__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(34071);
/* harmony import */ var utils_uiHelper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(19150);
/* harmony import */ var _FontSize__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(66707);
/* harmony import */ var components_elections_2023_ElectionsWidget__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(38562);
/* harmony import */ var components_faq__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(74892);
/* harmony import */ var _Ads_index__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(99126);
/* harmony import */ var constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(39712);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);








 // import Link from "next/link";







var RecengineWidget = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 4545).then(__webpack_require__.bind(__webpack_require__, 94545));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
      children: "Loading Recengine widget"
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(94545)];
    }
  }
});


 // import getConfig from "next/config";
// import moment from "moment";
// import ReactJWPlayer from "react-jw-player";
// import ClevertapReact from "utils/clevertapHelper";
// import { formatDate, formatDateIST, isoStringWithOffset } from "api/cleverTap";










 // import { baseUrl } from "api/constants";


 // import Sponsor from "components/Sponsor";



 // import SharePopup from "components/shared/modal/SharePopup";




var SharePopup = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1818), __webpack_require__.e(8419)]).then(__webpack_require__.bind(__webpack_require__, 98419));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
      children: "Loading Cricket widget"
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(98419)];
    }
  }
});
var WidgetHome = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4044), __webpack_require__.e(8087), __webpack_require__.e(7173)]).then(__webpack_require__.bind(__webpack_require__, 70014));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
      children: "Loading Cricket widget"
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(70014)];
    }
  }
});
var CommentSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6185), __webpack_require__.e(5454)]).then(__webpack_require__.bind(__webpack_require__, 75454));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
      children: "Comment Section"
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(75454)];
    }
  }
}); // const RelatedNews = dynamic(() => import("./relatedNews"));

var ArticleHTML = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7758), __webpack_require__.e(719), __webpack_require__.e(8764), __webpack_require__.e(653), __webpack_require__.e(7087)]).then(__webpack_require__.bind(__webpack_require__, 51458));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
      children: "Article HTML"
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(51458)];
    }
  }
});
var DynamicBanner = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 4495).then(__webpack_require__.bind(__webpack_require__, 43057));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
      children: "Dynamic banner"
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(43057)];
    }
  }
}); // const DropdownDiv = styled.div`
//   position: absolute;
//   right: 5px;
//   cursor: pointer;
// `;

var VideoPlayer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 1467).then(__webpack_require__.bind(__webpack_require__, 61467));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
      children: "Comment Section"
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61467)];
    }
  }
});
var TrendingToday = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 1244).then(__webpack_require__.bind(__webpack_require__, 51244));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
      children: "Comment Section"
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(51244)];
    }
  }
});
var CommentPopup = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 2133).then(__webpack_require__.bind(__webpack_require__, 22133));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
      children: "Comment Section"
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(22133)];
    }
  }
});
var CustomPopup = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 8773).then(__webpack_require__.bind(__webpack_require__, 78773));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
      children: "Comment Section"
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(78773)];
    }
  }
}); // const CricketSlider = dynamic(
//   () => import("../../components/homePage/cricketSlider"),
//   { ssr: true }
// );

var ReactJWPlayer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 7320).then(__webpack_require__.bind(__webpack_require__, 47320));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
      children: "Comment Section"
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(47320)];
    }
  }
});

var NewsDetailUpdated = function NewsDetailUpdated(_ref) {
  var _postData$createdByEm, _arraysData$indexonSc10, _arraysData$indexonSc11, _arraysData$indexonSc12, _arraysData$indexonSc13, _arraysData$indexonSc14, _arraysData$indexonSc15, _arraysData$indexonSc16, _arraysData$indexonSc17, _arraysData$indexonSc18, _arraysData$indexonSc19, _arraysData$indexonSc20, _arraysData$indexonSc21, _arraysData$indexonSc22, _arraysData$indexonSc23, _arraysData$indexonSc24, _arraysData$indexonSc25, _arraysData$indexonSc26, _arraysData$indexonSc27, _arraysData$indexonSc28, _arraysData$indexonSc29, _arraysData$indexonSc30, _arraysData$indexonSc31, _arraysData$indexonSc32, _arraysData$indexonSc33, _arraysData$indexonSc34, _arraysData$indexonSc35, _trendingData$entitie, _postData$seoData, _postData$seoData2, _postData$seoData3, _postData$seoData4, _postData$seoData5, _postData$seoData6, _postData$seoData7, _postData$additionalS2, _postData$additionalS3;

  var postData = _ref.postData,
      _ref$postType = _ref.postType,
      postType = _ref$postType === void 0 ? "" : _ref$postType,
      _ref$prevUrl = _ref.prevUrl,
      prevUrl = _ref$prevUrl === void 0 ? "" : _ref$prevUrl,
      _ref$trendingData = _ref.trendingData,
      trendingData = _ref$trendingData === void 0 ? "" : _ref$trendingData,
      _ref$articlePageBanne = _ref.articlePageBanners,
      articlePageBanners = _ref$articlePageBanne === void 0 ? [] : _ref$articlePageBanne,
      _ref$homePageVideos = _ref.homePageVideos,
      homePageVideos = _ref$homePageVideos === void 0 ? [] : _ref$homePageVideos,
      pointsData = _ref.pointsData,
      scoreData = _ref.scoreData,
      cricketTopicData = _ref.cricketTopicData,
      categoryName = _ref.categoryName;
  // console.log("articlePageBanners", postData);
  var shortsCards;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)(); // const [publicRuntimeConfig, setPublicRunTimeConfig] = useState({
  //   electionExitPollToggle: false,
  //   electionResultToggle: true,
  //   vidhansabhaResultToggle: true,
  //   resultVersion: 1.6,
  //   exitPollVersion: 1.2,
  //   electionYear: 2024,
  //   isElectionAlpha: true,
  //   keyCandidate: true,
  // });
  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     const remoteConfig = getRemoteConfig(app);
  //     remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
  //     fetchAndActivate(remoteConfig)
  //       .then(() => {
  //         // const titleData = getString(remoteConfig, "electionKeys");
  //         // const parsedData = JSON.parse(titleData);
  //         // setPublicRunTimeConfig(parsedData);
  //         // setVideoUrl(titleData);
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //       });
  //   }
  // }, []);

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useDispatch */ .I0)();
  var query = router.query; // const { asPath } = router;

  var ref = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)();
  var jwRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)();
  var isJWVisible = (0,hooks_useInViewport__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(jwRef);
  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_12__/* .useWindowSize */ .iP)();

  var _useSession = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.useSession)(),
      session = _useSession.data;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      loginPrompt = _useState[0],
      setLoginPrompt = _useState[1]; // const [videoUrl, setVideoUrl] = useState("");
  // const [showModal, setShowModal] = useState(false);


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([]),
      postStateData = _useState2[0],
      setPostStateData = _useState2[1]; // const [liked, setLiked] = useState(false);


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(""),
      language = _useState3[0],
      setLanguage = _useState3[1]; // const [countLike, setCountLike] = useState(postData?.likeCount);


  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)("large"),
      fontSize = _useState4[0],
      setFontSize = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      openShareModal = _useState5[0],
      setOpenShareModal = _useState5[1]; // const [shareData, setShareData] = useState({});


  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      loginShow = _useState6[0],
      setLoginShow = _useState6[1]; // const [isElection, setIsElection] = useState(false);


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      loadPlayer = _useState7[0],
      setLoadPlayer = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      showButton = _useState8[0],
      setShowButton = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(null),
      scrollDirection = _useState9[0],
      setScrollDirection = _useState9[1];

  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(true),
      isFirstTime = _useState10[0],
      setIsFirstTime = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      pageScrolled = _useState11[0],
      setPageScrolled = _useState11[1];

  var _useState12 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)("test"),
      test = _useState12[0],
      setTest = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([postData]),
      arraysData = _useState13[0],
      setArraysData = _useState13[1];

  var _useState14 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      callRosBottom = _useState14[0],
      setCallRosBottom = _useState14[1];

  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(0),
      indexonScreen = _useState15[0],
      setIndexOnScreen = _useState15[1];

  var _useState16 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)("jw-player-1"),
      currentPlayer = _useState16[0],
      setCurrentPlayer = _useState16[1];

  var _useState17 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      displayMore = _useState17[0],
      setDisplayMore = _useState17[1];

  var _useState18 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([true, false, false, false, false]),
      showMore = _useState18[0],
      setShowMore = _useState18[1];

  var _useState19 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      hideAppButton = _useState19[0],
      setHideAppButton = _useState19[1];

  var _useState20 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([postData === null || postData === void 0 ? void 0 : postData.isLiked]),
      infiniteLikeState = _useState20[0],
      setInfiniteLikeState = _useState20[1];

  var _useState21 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([postData === null || postData === void 0 ? void 0 : postData.isBookmarked]),
      infiniteBookmarkState = _useState21[0],
      setInfiniteBookmarkState = _useState21[1];

  var _useState22 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([]),
      relatedArticles = _useState22[0],
      setRelatedArticles = _useState22[1];

  var _useState23 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([]),
      restRelatedArticles = _useState23[0],
      setRestRelatedArticles = _useState23[1];

  var _useState24 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      articleChanges = _useState24[0],
      setArticleChanges = _useState24[1];

  var _useState25 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false),
      adCalled = _useState25[0],
      setAdCalled = _useState25[1];

  var _useSelector = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useSelector */ .v9)(function (_ref2) {
    var AuthReducer = _ref2.AuthReducer;
    return AuthReducer;
  }),
      userLocalDetail = _useSelector.userLocalDetail;

  var _useSelector2 = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useSelector */ .v9)(function (_ref3) {
    var PostReducer = _ref3.PostReducer;
    return PostReducer;
  }),
      postDetails = _useSelector2.postDetails;

  var _useState26 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([]),
      bookmarkArticleArray = _useState26[0],
      setBookmkarkArticleArray = _useState26[1]; // const { trendingPosts } = useSelector(({ PostReducer }) => PostReducer);


  var _useSelector3 = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useSelector */ .v9)(function (_ref4) {
    var AuthReducer = _ref4.AuthReducer;
    return AuthReducer;
  }),
      mobilePopUp = _useSelector3.mobilePopUp;

  var _useSelector4 = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useSelector */ .v9)(function (_ref5) {
    var PostReducer = _ref5.PostReducer;
    return PostReducer;
  }),
      statistics = _useSelector4.statistics;

  var testArray = [];
  var contentContainer; // console.log("arraysData postdata", arraysData);

  var _useState27 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([postData === null || postData === void 0 ? void 0 : postData._id]),
      bookmarkArray = _useState27[0],
      setBookmarkArray = _useState27[1];

  var _useState28 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(true),
      showStickyBanner = _useState28[0],
      setShowStickyBanner = _useState28[1];

  var authorName = postData === null || postData === void 0 ? void 0 : (_postData$createdByEm = postData.createdByEmail) === null || _postData$createdByEm === void 0 ? void 0 : _postData$createdByEm.split("@")[0];
  var mainUrl = "all";
  console.log("Article data for ", arraysData[0]);
  var masterConfigCT = (0,react__WEBPACK_IMPORTED_MODULE_8__.useContext)(constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_24__/* .MasterConfigContext */ .d); //Chunav Yatra
  // const [electionTopicData, setElectionTopicData] = useState([]);
  // const getElectionTopic = async () => {
  //   const res = await fetch(
  //     `${baseUrl}/topicItem/getContentsBySlugAndType?limit=6&skip=1&slug=chunav-yatra-2024&type=video`,
  //     {
  //       method: "GET",
  //       headers: {
  //         "content-type": "application/json",
  //       },
  //     }
  //   );
  //   const newPosts = await res.json();
  //   if (newPosts?.result?.entities?.length > 0) {
  //     console.log("Topic data for elction ", newPosts?.result?.entities);
  //     setElectionTopicData(newPosts?.result?.entities);
  //   } else {
  //     // setHasMore({ ...hasMore, [activeTab]: false });
  //   }
  //   // setSkipPerPage({ ...skipPerPage, [activeTab]: skipPerPage["text"] + 10 });
  //   // } else setLoginPrompt(true);
  // };
  // useEffect(() => {
  //   getElectionTopic();
  // }, []);
  // console.log("Election data", electionTopicData);
  // if (typeof window !== "undefined") {
  //   window.addEventListener("popstate", function (event) {
  //     location.replace("/");
  //     // router.push("/");
  //   });
  // }

  var handleCustomBack = function handleCustomBack() {
    if (prevUrl && articleChanges || !prevUrl.includes("post")) {
      router.push(prevUrl);
    } else {
      location.replace("/");
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    // window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handleCustomBack);
    return function () {
      window.removeEventListener("popstate", handleCustomBack);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    var jw_script = document.getElementById("__jw-ld-json");

    if (jw_script) {
      jw_script.parentNode.removeChild(jw_script);
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    var _document, _document2, _shortsCards, _shortsCards2;

    shortsCards = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelectorAll(".infinite");
    contentContainer = (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.getElementsByClassName(".content-container")[0];
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // console.log("entries", entry);
        if (entry.isIntersecting) {
          setArticleChanges(true);
          var index = parseInt(entry.target.className.split(" ")[2]);
          setIndexOnScreen(index);
          testArray.push(index); // console.log("index on screen  is", index, entry.target.className);

          if (index === 0 && testArray.length > 1 || index !== 0) {
            setTimeout(function () {
              if (typeof googletag.pubads === "function") {
                // console.log("Refresh fired");
                googletag.pubads().refresh();
              }
            }, 500);
          }
        } else {
          var index = parseInt(entry.target.className.split(" ")[2]);
          console.log("In observer going out of screen index", index);
        }
      });
    }, {
      threshold: 0.3,
      root: contentContainer
    });
    ((_shortsCards = shortsCards) === null || _shortsCards === void 0 ? void 0 : _shortsCards.length) > 0 && ((_shortsCards2 = shortsCards) === null || _shortsCards2 === void 0 ? void 0 : _shortsCards2.forEach(function (entry) {
      // console.log("In observer each", entry);
      observer.observe(entry);
    }));
  }, [arraysData]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    // Function to handle the intersection event of the first article
    var onIntersection = function onIntersection(entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // console.log("Comments section is in view!");
          // Optionally, you can stop observing once it's visible
          // observer.unobserve(entry.target);
          setIndexOnScreen(0);
        } else {// console.log("Comments section is not in view!");
        }
      });
    };

    var observer = new IntersectionObserver(onIntersection, {
      root: null,
      // Observe in the viewport
      rootMargin: "0px",
      // No margin
      threshold: 0.5 // 50% of the element must be visible

    }); // Get the comments section element

    var commentsSection = document.querySelector(".first-article-observer"); // Start observing the comments section

    observer.observe(commentsSection);
  }, [arraysData]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if (articleChanges) {
      changeUrl();
    }
  }, [indexonScreen]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    var _window = window,
        jwplayer = _window.jwplayer;

    if (jwplayer) {
      // console.log("Player exists in dom");
      delete window.jwplayer;
      var script = document.createElement("script");
      script.src = "https://cdn.jwplayer.com/libraries/gtSITKWv.js";
      script.defer = true; // Execute callback once the script has finished loading

      script.onload = function () {
        // console.log("Script loaded");
        setLoadPlayer(true);
      }; // Append the script tag to the document's head
      // document.head.appendChild(script);


      document.body.appendChild(script);
    } else {
      setLoadPlayer(true); // console.log("Player does not exists in dom");
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    console.log("isFirstTime", isFirstTime);
  }, [isFirstTime]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    var lastScrollY = window.pageYOffset;
    var animationFrameId;
    var scrollingTimeout;

    var updateScrollDirection = function updateScrollDirection() {
      setHideAppButton(true);
      setIsFirstTime(false);
      setPageScrolled(true);
      clearTimeout(scrollingTimeout);
      setCallRosBottom(true);
      cancelAnimationFrame(animationFrameId);
      animationFrameId = requestAnimationFrame(function () {
        scrollingTimeout = setTimeout(function () {
          setHideAppButton(false);
        }, 700);
      });
      var scrollY = window.screenY;
      var direction = scrollY > lastScrollY ? "down" : "up";

      if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
        setScrollDirection(direction);

        if (isFirstTime) {
          setIsFirstTime(false);
        }
      }

      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    window.addEventListener("scroll", updateScrollDirection); // add event listener

    return function () {
      window.removeEventListener("scroll", updateScrollDirection);
    };
  }, [scrollDirection, isFirstTime]); // useEffect(() => {
  //   dispatch(getTrendingPosts());
  // }, [dispatch]);

  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    runChartBeatScript();
  }, [indexonScreen]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if (!isFirstTime) {
      runScripts();
      fetchRelatedArticles(postData._id);
    }
  }, [isFirstTime]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    setTimeout(function () {
      if (typeof window.gtag !== "undefined") {
        gtag("create", "G-RXRPKR4310", "auto");
        gtag("create", "G-6DCEWMBVGD", "auto"); // ga("set", "dimension1", "thelallantop.com");
        // ga("set", "dimension2", `${postData?.categorySlug}`);
        // let date = new Date().toISOString().slice(0, 10);
        // ga("set", "dimension3", `${date}`);
        // ga("send", "pageView", {
        //   eventCategory: `${postData?.type === "text" ? "articles" : "videos"}`,
        //   eventLabel: `page_view_${postData.englishTitle}`,
        //   eventValue: `${postData.permalink}`,
        // });

        if ((postData === null || postData === void 0 ? void 0 : postData.type) === "text") {
          var page_article_data_video = {};
          page_article_data_video["send_to"] = "G-RXRPKR4310";
          page_article_data_video["eventCategory"] = "Article Pages";
          page_article_data_video["eventLabel"] = "page_view_".concat(postData.englishTitle);
          page_article_data_video["eventValue"] = "".concat(postData.permalink);
          gtag("event", "article_page_view", page_article_data_video);
        } else {
          var page_article_data = {};
          page_article_data["send_to"] = "G-RXRPKR4310";
          page_article_data["eventCategory"] = "Video Pages";
          page_article_data["eventLabel"] = "page_view_".concat(postData.englishTitle);
          page_article_data["eventValue"] = "".concat(postData.permalink);
          gtag("event", "video_page_view", page_article_data);
          var page_article_data2 = {};
          page_article_data2["send_to"] = "G-6DCEWMBVGD";
          page_article_data2["eventCategory"] = "Video Pages";
          page_article_data2["eventLabel"] = "page_view_".concat(postData.englishTitle);
          page_article_data2["eventValue"] = "".concat(postData.permalink);
          gtag("event", "video_page_view", page_article_data2);
        }
      }
    }, 1500);
  }, [isFirstTime]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if ((relatedArticles === null || relatedArticles === void 0 ? void 0 : relatedArticles.length) > 0) {
      fetchArticleData();
    }
  }, [relatedArticles]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    setPostStateData(postData); // if (postData) {
    //   // setLiked(postData?.isLiked);
    // }
  }, [postData]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if (postData !== null && postData !== void 0 && postData.postId ? (postDetails === null || postDetails === void 0 ? void 0 : postDetails._id) === (postData === null || postData === void 0 ? void 0 : postData.postId) : (postDetails === null || postDetails === void 0 ? void 0 : postDetails._id) === (postData === null || postData === void 0 ? void 0 : postData._id)) {
      setPostStateData(postDetails); // setLiked(postDetails?.isLiked);
      // setCountLike(postDetails?.likeCount);
    }
  }, [postDetails, postData === null || postData === void 0 ? void 0 : postData._id, postData === null || postData === void 0 ? void 0 : postData.postId]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    var _postData$additionalS;

    if (!postData || !(postData !== null && postData !== void 0 && (_postData$additionalS = postData.additionalSchemas) !== null && _postData$additionalS !== void 0 && _postData$additionalS.length) > 0) return;
    var additionalSchema = postData === null || postData === void 0 ? void 0 : postData.additionalSchemas[0];
    var script = document.createElement("script");
    script.type = "application/ld+json";
    var jsonLdData = {
      "@context": additionalSchema === null || additionalSchema === void 0 ? void 0 : additionalSchema.context,
      "@type": additionalSchema === null || additionalSchema === void 0 ? void 0 : additionalSchema.type,
      "actor": additionalSchema === null || additionalSchema === void 0 ? void 0 : additionalSchema.actors,
      "dateCreated": additionalSchema === null || additionalSchema === void 0 ? void 0 : additionalSchema.dateCreated,
      "description": additionalSchema === null || additionalSchema === void 0 ? void 0 : additionalSchema.description,
      "director": additionalSchema === null || additionalSchema === void 0 ? void 0 : additionalSchema.director,
      "image": additionalSchema === null || additionalSchema === void 0 ? void 0 : additionalSchema.image,
      "name": additionalSchema === null || additionalSchema === void 0 ? void 0 : additionalSchema.name,
      "review": additionalSchema === null || additionalSchema === void 0 ? void 0 : additionalSchema.review,
      "sameAs": additionalSchema === null || additionalSchema === void 0 ? void 0 : additionalSchema.sameAs,
      "url": additionalSchema === null || additionalSchema === void 0 ? void 0 : additionalSchema.url
    };
    script.text = JSON.stringify(additionalSchema); // Optional: remove old script if exists

    var existing = document.getElementById("my-script-movie");

    if (existing) {
      existing.remove();
    }

    script.id = "my-script-movie";
    document.head.appendChild(script);
  }, [postData]); // useEffect(()=>{
  //   window._comscore = window._comscore || [];
  //     // Push Comscore configuration
  //     window._comscore.push({
  //       c1: "2",
  //       c2: "8549097",
  //       options: {
  //         enableFirstPartyCookie: true
  //       }
  //     });
  //     // Create <script> element
  //     const script = document.createElement('script');
  //     script.async = true;
  //     script.src = "https://sb.scorecardresearch.com/cs/8549097/beacon.js";
  //     // Find the first script element on the page
  //     const firstScript = document.getElementsByTagName('script')[0];
  //     // Insert the new script before the first script element
  //     firstScript.parentNode.insertBefore(script, firstScript);
  // },[]);

  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    (0,utils_deviceIdGenerator__WEBPACK_IMPORTED_MODULE_17__/* .GenerateUniqId */ .N)().then(function (deviceId) {
      var viewObj = {
        postId: postData._id,
        deviceType: "web",
        deviceId: deviceId
      };
      dispatch((0,redux_actions_postAction__WEBPACK_IMPORTED_MODULE_25__/* .storyView */ .Kw)(viewObj, postType));
    });
  }, [postData === null || postData === void 0 ? void 0 : postData._id, postType, dispatch]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    setLanguage((0,localization_i8intl__WEBPACK_IMPORTED_MODULE_16__/* .getLanguage */ .G3)());
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    dispatch((0,redux_actions_ads_Actions__WEBPACK_IMPORTED_MODULE_26__/* .getAdsBySize */ .R)());
  }, [dispatch]); // useEffect(() => {
  //   if (router.asPath.includes("/sports")) {
  //     const script = document.createElement("script");
  //     script.innerHTML = `
  //     window._izq = window._izq || [];
  //     window._izq.push(["userProfile", {
  //       "add": {
  //         "Category": "Sports"
  //       }
  //     }]);
  //   `;
  //     script.defer = true;
  //     document.head.appendChild(script);
  //   }
  //   return () => {
  //     document.head.removeChild(script); // Cleanup when component unmounts
  //   };
  // }, []);
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (
  //       size.width < 600 &&
  //       router?.pathname.includes("/post/") &&
  //       mobilePopUp < 1
  //     ) {
  //       setShowAppRedirection(true);
  //       dispatch(handleMobilePopUpSuccess());
  //     }
  //   }, 5000);
  //   return () => clearTimeout(timer);
  // }, [size]);

  function handleCommentClick() {
    var showMoreButton = document.querySelector(".tbl-read-more-btn ");

    if (showMoreButton) {
      showMoreButton.click();
    }

    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth"
      });
    }
  } // useEffect(() => {
  //   if (postData?.assetFileLink?.includes("video.m3u8")) {
  //     let file = postData?.assetFileLink?.replace("video.m3u8", "video.mp4");
  //     // setVideoUrl(file);
  //   } else if (postData?.assetFileLink?.includes("master.m3u8")) {
  //     let file1 = postData?.assetFileLink?.replace("master.m3u8", "video.mp4");
  //     // setVideoUrl(file1);
  //   } else {
  //     let file2 = postData?.assetFileLink;
  //     // setVideoUrl(file2);
  //   }
  // }, [postData]);


  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if (window && typeof window.localStorage !== "undefined") {
      var fs = window.localStorage.getItem("fontSize");

      if (fs && ["small", "normal", "large"].includes(fs)) {
        setFontSize(fs);
      }
    }
  }, [fontSize]); // useEffect(() => {
  //   fetch(`${baseUrl}/live/listWithStreamUrl?limit=12&skip=1`)
  //     .then((res) => res.json())
  //     .then((d) => {
  //       setIsElection(d?.result?.entities[0]?.isElection);
  //     });
  // }, []);

  var handleLike = function handleLike(postObj, postDetails, index) {
    var _session$user;

    if (userLocalDetail !== null && userLocalDetail !== void 0 && userLocalDetail.id || session !== null && session !== void 0 && (_session$user = session.user) !== null && _session$user !== void 0 && _session$user.email) {
      dispatch((0,redux_actions_postAction__WEBPACK_IMPORTED_MODULE_25__/* .postLike */ .mT)(postObj, postType, postDetails));

      var alteredLikeArr = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(infiniteLikeState);

      alteredLikeArr[index] = !infiniteLikeState[index];
      setInfiniteLikeState(alteredLikeArr);
    } else {
      setLoginShow(true);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    var _session$user2;

    if (userLocalDetail !== null && userLocalDetail !== void 0 && userLocalDetail.id || session !== null && session !== void 0 && (_session$user2 = session.user) !== null && _session$user2 !== void 0 && _session$user2.email) {
      dispatch((0,redux_actions_postAction__WEBPACK_IMPORTED_MODULE_25__/* .getStats */ .fy)(postData === null || postData === void 0 ? void 0 : postData._id));
    }
  }, []);

  var handleClose = function handleClose() {
    setShowButton(function (e) {
      return !e;
    });
  };

  var handleBookmark = function handleBookmark(_id, type, index) {
    var _session$user3;

    if (userLocalDetail !== null && userLocalDetail !== void 0 && userLocalDetail.id || session !== null && session !== void 0 && (_session$user3 = session.user) !== null && _session$user3 !== void 0 && _session$user3.email) {
      var _bookmarkArticleArray;

      var postObj = {
        table: "post",
        postId: _id,
        type: type
      };
      dispatch((0,redux_actions_bookmarksActions__WEBPACK_IMPORTED_MODULE_28__/* .saveBookmark */ .Bn)(postObj));

      var alteredBookArr = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(infiniteBookmarkState);

      alteredBookArr[index] = !infiniteBookmarkState[index];
      setInfiniteBookmarkState(alteredBookArr); //setShowDropdown((e) => !e);

      bookmarkArticleArray[index].isBookmarked = (_bookmarkArticleArray = bookmarkArticleArray[index]) !== null && _bookmarkArticleArray !== void 0 && _bookmarkArticleArray.isBookmarked ? false : true;
    } else {
      if (setLoginShow) setLoginShow(true);
    }
  };

  var handleShare = function handleShare(articleData) {
    var share = {
      title: articleData === null || articleData === void 0 ? void 0 : articleData.title,
      text: articleData === null || articleData === void 0 ? void 0 : articleData.title
    }; //if (shareUrl) share.url = shareUrl;

    share.url = (articleData === null || articleData === void 0 ? void 0 : articleData.permalink) + "?utm_source=Internal_LT&utm_medium=".concat(postData === null || postData === void 0 ? void 0 : postData.type, "&utm_name=system-share"); //console.log("share: ", share);
    // setShareData(share);

    if (!navigator || !navigator.share) {
      setOpenShareModal(true); // console.log("Platform not supported!");
    } else {
      utils_uiHelper__WEBPACK_IMPORTED_MODULE_19__/* ["default"].share */ .Z.share(share);
    }
  };

  var changeUrl = function changeUrl() {
    if (indexonScreen === 0) {
      var currentURL = window.location.href;
      var count = 0;
      var baseURl = "";

      (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(currentURL).forEach(function (c) {
        if (c === "/") {
          count++;
        }

        if (count < 3) {
          baseURl += c;
        }
      });

      baseURl = baseURl + "/" + arraysData[0].categorySlug + "/post/" + arraysData[0].postSlug;
      window.history.pushState({}, document.title, baseURl);
    } else {
      var _arraysData$indexonSc, _arraysData$indexonSc2;

      var currentURL = window.location.href;
      var _count = 0;
      var _baseURl = "";

      (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(currentURL).forEach(function (c) {
        if (c === "/") {
          _count++;
        }

        if (_count < 3) {
          _baseURl += c;
        }
      });

      _baseURl = _baseURl + "/" + ((_arraysData$indexonSc = arraysData[indexonScreen]) === null || _arraysData$indexonSc === void 0 ? void 0 : _arraysData$indexonSc.categorySlug) + "/post/" + ((_arraysData$indexonSc2 = arraysData[indexonScreen]) === null || _arraysData$indexonSc2 === void 0 ? void 0 : _arraysData$indexonSc2.postSlug);
      window.history.pushState({}, document.title, _baseURl);
      window._comscore = window._comscore || []; // Push Comscore configuration

      window._comscore.push({
        c1: "2",
        c2: "8549097",
        cs_ucfr: "",
        options: {
          enableFirstPartyCookie: true,
          bypassUserConsentRequirementFor1PCookie: true
        } // cs_ucfr: 0,
        // options: {
        //   enableFirstPartyCookie: true,
        // },

      }); // Create <script> element


      var script = document.createElement("script");
      script.async = true;
      script.src = "https://sb.scorecardresearch.com/cs/8549097/beacon.js"; // Find the first script element on the page

      var firstScript = document.getElementsByTagName("script")[0]; // Insert the new script before the first script element

      firstScript.parentNode.insertBefore(script, firstScript);
      apstag.fetchBids({
        slots: size.width < 768 ? (0,_Ads_index__WEBPACK_IMPORTED_MODULE_23__/* .createApsSlotsRosMobile */ .PI)({}) : (0,_Ads_index__WEBPACK_IMPORTED_MODULE_23__/* .createApsSlotsRosDesktop */ .VG)({}),
        timeout: 2e3
      }, _Ads_index__WEBPACK_IMPORTED_MODULE_23__/* .apstagBidCallback */ .O8);
      var script2 = document.createElement('script');
      script2.type = 'text/javascript';
      script2.async = true;
      script2.src = "//pb-script-03.ccgateway.net/script?id=cca&parentId=" + window.location.hostname; // Append the script to the document
      // document.body.appendChild(script);

      document.body.appendChild(script2);
    }
  };

  var handleVideoPlay = /*#__PURE__*/function () {
    var _ref6 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(currentId) {
      var _window2, jwplayer;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (window !== undefined) {
                _window2 = window, jwplayer = _window2.jwplayer;

                if (jwplayer && currentPlayer !== currentId) {
                  // jwplayer(currentId).setFloating(true)
                  jwplayer(currentPlayer).pause();
                  jwplayer(currentPlayer).setFloating(false);
                } else {// console.log("jwplayer not found or same player");
                }
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleVideoPlay(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  function shareLinkToWhatsApp(articleData) {
    var _arraysData$indexonSc3, _arraysData$indexonSc4, _arraysData$indexonSc5;

    var share = {
      title: (_arraysData$indexonSc3 = arraysData[indexonScreen]) === null || _arraysData$indexonSc3 === void 0 ? void 0 : _arraysData$indexonSc3.title,
      text: (_arraysData$indexonSc4 = arraysData[indexonScreen]) === null || _arraysData$indexonSc4 === void 0 ? void 0 : _arraysData$indexonSc4.title
    }; //if (shareUrl) share.url = shareUrl;

    share.url = ((_arraysData$indexonSc5 = arraysData[indexonScreen]) === null || _arraysData$indexonSc5 === void 0 ? void 0 : _arraysData$indexonSc5.permalink) + "?utm_source=Internal_LT&utm_medium=".concat(postData === null || postData === void 0 ? void 0 : postData.type, "&utm_name=whatsapp-share");
    var whatsappLink = "whatsapp://send?text=".concat(encodeURIComponent("".concat(share.title, " ").concat(share.url)));
    window.location.href = whatsappLink;
  } // const countFormat = (count) => {
  //   return count > 1000 ? (count / 1000).toFixed(1).concat("k") : count;
  // };


  var keywords = arraysData[indexonScreen] && arraysData[indexonScreen].altTags ? arraysData[indexonScreen].altTags.toString() : "";
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    // console.log("Calling ads");
    var showAds = true;

    if (false) {}

    if (showAds && !adCalled) {
      setAdCalled(true);
      setTimeout(function () {
        // console.log("showAds", showAds, process.env.NEXT_PUBLIC_ADS_ONSCROLL);
        window.googletag = window.googletag || {
          cmd: []
        };

        if (window.screen.width > 600) {
          googletag.cmd.push(function () {
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_728x90", [[728, 90], [970, 250], [970, 90]], "div-gpt-ad-1701945163318-0").addService(googletag.pubads());
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_300x250", [300, 250], "div-gpt-ad-1701945220410-0").addService(googletag.pubads()); // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Desktop_ROS_MTF_1_728x90",
            //     [728, 90],
            //     "div-gpt-ad-1701945220410-1"
            //   )
            //   .addService(googletag.pubads());
            // if (removeEmbeds(postData?.articleHTML).split("</p>").length >= 4) {
            //   googletag
            //     .defineSlot(
            //       "/1007232/Lallantop_Desktop_ROS_MTF_2_728x90",
            //       [728, 90],
            //       "div-gpt-ad-1701945220410-2"
            //     )
            //     .addService(googletag.pubads());
            // }

            if ((postData === null || postData === void 0 ? void 0 : postData.type) === "text") {
              googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_3_728x90", [728, 90], "div-gpt-ad-1701945220410-3").addService(googletag.pubads());
            }

            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_BTF_300x250", [[300, 250], [300, 600]], "div-gpt-ad-1701945864013-0").addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", "".concat(categoryName, ",story,").concat(postData === null || postData === void 0 ? void 0 : postData._id));
            googletag.pubads().setTargeting("Keywords", keywords);
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,_Ads_index__WEBPACK_IMPORTED_MODULE_23__/* .requestBiddingFromPWT */ .WX)();
          });
        } else {
          googletag.cmd.push(function () {
            googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_ATF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-0").addService(googletag.pubads()); // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Mobile_ROS_MTF_1_300x250",
            //     [
            //       [336, 280],
            //       [300, 250],
            //     ],
            //     "div-gpt-ad-1701946028239-1"
            //   )
            //   .addService(googletag.pubads());
            // if (removeEmbeds(postData?.articleHTML).split("</p>").length >= 4) {
            //   googletag
            //     .defineSlot(
            //       "/1007232/Lallantop_Mobile_ROS_MTF_2_300x250",
            //       [
            //         [336, 280],
            //         [300, 250],
            //       ],
            //       "div-gpt-ad-1701946028239-2"
            //     )
            //     .addService(googletag.pubads());
            // }

            googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_BTF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-3").addService(googletag.pubads()); // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Mobile_ROS_Bottom_320x50",
            //     [320, 50],
            //     "div-gpt-ad-1701946324333-0"
            //   )
            //   .addService(googletag.pubads());

            googletag.defineOutOfPageSlot("/1007232/Lallantop_Mobile_ROS_Mweb_Interstitial", googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", "".concat(categoryName, ",story,").concat(postData === null || postData === void 0 ? void 0 : postData._id));
            googletag.pubads().setTargeting("Keywords", keywords);
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,_Ads_index__WEBPACK_IMPORTED_MODULE_23__/* .requestBiddingFromPWT */ .WX)();
          });
        } // apstag.fetchBids(
        //   {
        //     slots:
        //       size?.width < 499
        //         ? createApsSlotsRosMobile({})
        //         : createApsSlotsRosDesktop({}),
        //     timeout: 2e3,
        //   },
        //   apstagBidCallback
        // );

      }, 500);
    }
  }, [postData, isFirstTime]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if (pageScrolled) {
      window.googletag = window.googletag || {
        cmd: []
      };

      if (window.screen.width > 600) {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_1_728x90", [728, 90], "div-gpt-ad-1701945220410-1").addService(googletag.pubads());

          if ((0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_13__/* .removeEmbeds */ .q3)(postData === null || postData === void 0 ? void 0 : postData.articleHTML).split("</p>").length >= 4) {
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_2_728x90", [728, 90], "div-gpt-ad-1701945220410-2").addService(googletag.pubads());
          }

          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", "".concat(categoryName, ",story,").concat(postData === null || postData === void 0 ? void 0 : postData._id));
          googletag.pubads().setTargeting("Keywords", keywords);
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          (0,_Ads_index__WEBPACK_IMPORTED_MODULE_23__/* .requestBiddingFromPWT */ .WX)();
        });
      } else {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_1_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-1").addService(googletag.pubads());

          if ((0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_13__/* .removeEmbeds */ .q3)(postData === null || postData === void 0 ? void 0 : postData.articleHTML).split("</p>").length >= 4) {
            googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_2_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-2").addService(googletag.pubads());
          }

          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", "".concat(categoryName, ",story,").concat(postData === null || postData === void 0 ? void 0 : postData._id));
          googletag.pubads().setTargeting("Keywords", keywords);
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          (0,_Ads_index__WEBPACK_IMPORTED_MODULE_23__/* .requestBiddingFromPWT */ .WX)();
        });
      }
    }
  }, [pageScrolled]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if (callRosBottom) {
      window.googletag = window.googletag || {
        cmd: []
      };

      if (window.screen.width <= 600) {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_Bottom_320x50", [320, 50], "div-gpt-ad-1701946324333-0").addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", "".concat(categoryName, ",story,").concat(postData === null || postData === void 0 ? void 0 : postData._id));
          googletag.pubads().setTargeting("Keywords", keywords);
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          (0,_Ads_index__WEBPACK_IMPORTED_MODULE_23__/* .requestBiddingFromPWT */ .WX)();
        });
      }
    }
  }, [callRosBottom]);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if (size.width) {
      apstag.fetchBids({
        slots: size.width < 768 ? (0,_Ads_index__WEBPACK_IMPORTED_MODULE_23__/* .createApsSlotsRosMobile */ .PI)({}) : (0,_Ads_index__WEBPACK_IMPORTED_MODULE_23__/* .createApsSlotsRosDesktop */ .VG)({}),
        timeout: 2e3
      }, _Ads_index__WEBPACK_IMPORTED_MODULE_23__/* .apstagBidCallback */ .O8);
    }
  }, [size.width]);

  var runChartBeatScript = function runChartBeatScript() {
    (function () {
      var _arraysData$indexonSc6, _arraysData$indexonSc7, _arraysData$indexonSc8, _arraysData$indexonSc9;

      /* CONFIGURATION START */
      var _sf_async_config = window._sf_async_config = window._sf_async_config || {};

      _sf_async_config.uid = 60355;
      _sf_async_config.domain = "thelallantop.com";
      _sf_async_config.useCanonical = true;
      _sf_async_config.useCanonicalDomain = true;
      _sf_async_config.sections = "".concat((_arraysData$indexonSc6 = arraysData[indexonScreen]) === null || _arraysData$indexonSc6 === void 0 ? void 0 : _arraysData$indexonSc6.categorySlug);
      _sf_async_config.authors = "".concat((_arraysData$indexonSc7 = arraysData[indexonScreen]) === null || _arraysData$indexonSc7 === void 0 ? void 0 : (_arraysData$indexonSc8 = _arraysData$indexonSc7.contentAuthors[0]) === null || _arraysData$indexonSc8 === void 0 ? void 0 : _arraysData$indexonSc8.fullname);
      _sf_async_config.path = "/".concat((_arraysData$indexonSc9 = arraysData[indexonScreen]) === null || _arraysData$indexonSc9 === void 0 ? void 0 : _arraysData$indexonSc9.categorySlug, "/post/").concat(arraysData[indexonScreen].postSlug);
      /* CONFIGURATION END */

      function loadChartbeat() {
        var e = document.createElement("script");
        var n = document.getElementsByTagName("script")[0];
        e.type = "text/javascript";
        e.async = true;
        e.defer = true;

        if ((postData === null || postData === void 0 ? void 0 : postData.type) === "video") {
          e.src = "//static.chartbeat.com/js/chartbeat_video.js";
        } else {
          e.src = "//static.chartbeat.com/js/chartbeat.js";
        }

        n.parentNode.insertBefore(e, n);
      }

      setTimeout(function () {
        loadChartbeat();
      }, 500);
      loadChartbeat();
      var twitter = document.createElement("script");
      twitter.setAttribute("src", "https://platform.twitter.com/widgets.js");
      twitter.setAttribute("async", "true");
      twitter.setAttribute("defer", "true"); // document.head.appendChild(twitter);

      document.body.appendChild(twitter);
      var facebook = document.createElement("script");
      twitter.setAttribute("src", "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2");
      twitter.setAttribute("async", "true");
      twitter.setAttribute("defer", "true"); // document.head.appendChild(facebook);

      document.body.appendChild(facebook);
      var reddit = document.createElement("script");
      reddit.setAttribute("src", "https://embed.reddit.com/widgets.js");
      reddit.setAttribute("async", "true");
      reddit.setAttribute("defer", "true"); // document.head.appendChild(reddit);

      document.body.appendChild(reddit);
    })();
  };

  var runScripts = function runScripts() {
    //console.log("Scripts Called");
    if ((postData === null || postData === void 0 ? void 0 : postData.type) !== "video") {
      (function (v, d, o, ai) {
        ai = d.createElement("script");
        ai.defer = true;
        ai.async = true;
        ai.src = v.location.protocol + o;
        d.head.appendChild(ai);
      })(window, document, "//a.vdo.ai/core/v-thelallantop/vdo.ai.js");

      window, document, "//a.vdo.ai/core/v-thelallantop-v1/vdo.ai.js";
    } else {
      (function (v, d, o, ai) {
        ai = d.createElement("script");
        ai.defer = true;
        ai.async = true;
        ai.src = v.location.protocol + o;
        d.head.appendChild(ai);
      })(window, document, "//a.vdo.ai/core/v-thelallantop-v1/vdo.ai.js");
    }

    window._taboola = window._taboola || [];

    _taboola.push({
      article: "auto"
    });

    !function (e, f, u, i) {
      if (!document.getElementById(i)) {
        e.async = 1;
        e.src = u;
        e.id = i;
        f.parentNode.insertBefore(e, f);
      }
    }(document.createElement("script"), document.getElementsByTagName("script")[0], "//cdn.taboola.com/libtrc/indiatoday-thelallantop/loader.js", "tb_loader_script");

    if (window.performance && typeof window.performance.mark == "function") {
      window.performance.mark("tbl_ic");
    }

    window._taboola = window._taboola || [];

    _taboola.push({
      mode: "alternating-thumbnails-a",
      container: "taboola-below-article-thumbnails",
      placement: "Below Article Thumbnails",
      target_type: "mix"
    }); // (function () {
    //   /* CONFIGURATION START */
    //   var _sf_async_config = (window._sf_async_config =
    //     window._sf_async_config || {});
    //   _sf_async_config.uid = 60355;
    //   _sf_async_config.domain = "thelallantop.com";
    //   _sf_async_config.useCanonical = true;
    //   _sf_async_config.useCanonicalDomain = true;
    //   _sf_async_config.sections = `${postData?.categorySlug}`;
    //   _sf_async_config.authors = `${postData?.contentAuthors[0]?.fullname}`;
    //   /* CONFIGURATION END */
    //   function loadChartbeat() {
    //     var e = document.createElement("script");
    //     var n = document.getElementsByTagName("script")[0];
    //     e.type = "text/javascript";
    //     e.async = true;
    //     if (postData?.type === "video") {
    //       e.src = "//static.chartbeat.com/js/chartbeat_video.js";
    //     } else {
    //       e.src = "//static.chartbeat.com/js/chartbeat.js";
    //     }
    //     n.parentNode.insertBefore(e, n);
    //   }
    //   loadChartbeat();
    //   const twitter = document.createElement("script");
    //   twitter.setAttribute("src", "https://platform.twitter.com/widgets.js");
    //   twitter.setAttribute("async", "true");
    //   document.head.appendChild(twitter);
    //   const reddit = document.createElement("script");
    //   reddit.setAttribute("src", "https://embed.reddit.com/widgets.js");
    //   reddit.setAttribute("async", "true");
    //   document.head.appendChild(reddit);
    // })();

  };

  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if (relatedArticles.length > 1) {
      var ar = [];
      relatedArticles.forEach(function (article) {
        ar.push(article === null || article === void 0 ? void 0 : article._id);
      });
      setBookmarkArray([].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(bookmarkArray), ar));
    }
  }, [relatedArticles]);

  var fetchRelatedArticles = /*#__PURE__*/function () {
    var _ref7 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(id) {
      var data, amp, dat;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_30__/* .baseUrlV2 */ .aG, "/web/related-article?_id=").concat(id, "&type=text"), {
                headers: {
                  accesstype: "web"
                }
              });

            case 2:
              data = _context2.sent;
              _context2.next = 5;
              return data.json();

            case 5:
              amp = _context2.sent;
              dat = amp === null || amp === void 0 ? void 0 : amp.result;
              setRelatedArticles(dat);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchRelatedArticles(_x2) {
      return _ref7.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    var _session$user4;

    if (bookmarkArray.length > 1 && (userLocalDetail !== null && userLocalDetail !== void 0 && userLocalDetail.id || session !== null && session !== void 0 && (_session$user4 = session.user) !== null && _session$user4 !== void 0 && _session$user4.email)) {
      var articlesBookmark = [{}, {}, {}, {}, {}];
      bookmarkArray.forEach( /*#__PURE__*/function () {
        var _ref8 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(item, index) {
          var token, axios, res;
          return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  token = (0,constants_loginConstants__WEBPACK_IMPORTED_MODULE_14__/* .getTokenFromCookies */ .$z)(document.cookie);
                  _context3.next = 3;
                  return (0,api_apiInstance__WEBPACK_IMPORTED_MODULE_11__/* .getAuthorizedApi */ .QJ)(token);

                case 3:
                  axios = _context3.sent;
                  _context3.next = 6;
                  return axios.post("".concat("https://api.thelallantop.com", "/v2/web/getStatistics"), {
                    _id: item
                  });

                case 6:
                  res = _context3.sent;
                  articlesBookmark[index] = res.data.result;
                  setBookmkarkArticleArray(articlesBookmark);

                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3, _x4) {
          return _ref8.apply(this, arguments);
        };
      }());
    }
  }, [bookmarkArray]);

  var fetchArticleData = /*#__PURE__*/function () {
    var _ref9 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
      var ar, token, accessToken, headers, x, data, amp, dat, likeArray, bookmarkArray;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // fetchRelatedArticles(postData._id);
              ar = [];
              token = (0,constants_loginConstants__WEBPACK_IMPORTED_MODULE_14__/* .getTokenFromCookies */ .$z)(document.cookie);
              _context4.next = 4;
              return (0,utils_encryption__WEBPACK_IMPORTED_MODULE_18__/* .decryptData */ .o)(token);

            case 4:
              accessToken = _context4.sent;

              if (accessToken) {
                headers = {
                  method: "GET",
                  headers: {
                    "content-type": "application/json",
                    Authorization: "Bearer ".concat(accessToken)
                  }
                };
              } else {
                headers = {
                  method: "GET",
                  headers: {
                    "content-type": "application/json"
                  }
                };
              }

              x = 0;

            case 7:
              if (!(x < 4)) {
                _context4.next = 19;
                break;
              }

              _context4.next = 10;
              return fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_30__/* .baseUrlV2 */ .aG, "/web/postDetailsByCategory/").concat(relatedArticles[x].categorySlug, "/").concat(relatedArticles[x].postSlug, "?accessType=web"), headers);

            case 10:
              data = _context4.sent;
              _context4.next = 13;
              return data.json();

            case 13:
              amp = _context4.sent;
              dat = amp === null || amp === void 0 ? void 0 : amp.result;
              ar.push(dat);

            case 16:
              x++;
              _context4.next = 7;
              break;

            case 19:
              if ((arraysData === null || arraysData === void 0 ? void 0 : arraysData.length) > 0) {
                setArraysData([].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(arraysData), ar));
              }

              likeArray = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(infiniteLikeState);
              bookmarkArray = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(infiniteBookmarkState);
              ar === null || ar === void 0 ? void 0 : ar.forEach(function (article, articleIndex) {
                likeArray.push(article === null || article === void 0 ? void 0 : article.isLiked);
                bookmarkArray.push(article === null || article === void 0 ? void 0 : article.isBookmarked);
              });
              setInfiniteBookmarkState(bookmarkArray);
              setInfiniteLikeState(likeArray);

            case 25:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function fetchArticleData() {
      return _ref9.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {// console.log("arraysData", arraysData);
  }, [arraysData]);

  var handleReadMore = function handleReadMore(showIndex) {
    var newShowArr = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(showMore);

    newShowArr[showIndex] = true;
    setShowMore(newShowArr);
  }; // const convertToIST = (inputTime) => {
  //   const utcDate = new Date(inputTime);
  //   // Remove milliseconds
  //   utcDate.setMilliseconds(0);
  //   // Add 5 hours and 30 minutes to convert to IST
  //   const istDate = new Date(utcDate.getTime());
  //   // Format IST date components
  //   const year = istDate.getUTCFullYear();
  //   const month = String(istDate.getUTCMonth() + 1).padStart(2, "0");
  //   const day = String(istDate.getUTCDate()).padStart(2, "0");
  //   const hours = String(istDate.getUTCHours()).padStart(2, "0");
  //   const minutes = String(istDate.getUTCMinutes()).padStart(2, "0");
  //   const seconds = String(istDate.getUTCSeconds()).padStart(2, "0");
  //   // Construct the IST time string
  //   // var istTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+05:30`;
  //   var istTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  //   var originalTime = new Date(istTime);
  //   // Add 5 hours and 30 minutes
  //   originalTime.setHours(originalTime.getHours() + 5);
  //   originalTime.setMinutes(originalTime.getMinutes() + 30);
  //   // Format the result
  //   var formattedTime =
  //     typeof originalTime === Date &&
  //     originalTime?.toISOString()?.slice(0, 19)?.replace("T", "T");
  //   formattedTime = formattedTime + "+05:30";
  //   return formattedTime;
  // };


  var convertToIST = function convertToIST() {
    var dateTimeString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    try {
      // Split the datetime string into date and time parts
      var _dateTimeString$split = dateTimeString === null || dateTimeString === void 0 ? void 0 : dateTimeString.split(" "),
          _dateTimeString$split2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(_dateTimeString$split, 2),
          datePart = _dateTimeString$split2[0],
          timePart = _dateTimeString$split2[1]; // Concatenate the date and time parts with 'T' in between


      var isoDateTime = "".concat(datePart, "T").concat(timePart); // Append the timezone offset

      var isoDateTimeWithOffset = isoDateTime + "+05:30";
      return isoDateTimeWithOffset;
    } catch (error) {
      console.error(error);
      return dateTimeString;
    }
  };

  var handleScroll = function handleScroll() {
    var isScrolling = document.body.scrollHeight > window.innerHeight;
    setIsNotScrolling(!isScrolling);
  }; // console.log("PostData ", postData);


  console.log("array of showMore ", showMore);
  var aspectRatio = size.width > size.height ? size.width / size.height : size.height / size.width;
  console.log("aspect ratio is ", aspectRatio);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
    style: {
      minHeight: "90vh"
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("link", {
        rel: "amphtml",
        href: "".concat("https://www.thelallantop.com", "/amp/").concat((_arraysData$indexonSc10 = arraysData[indexonScreen]) === null || _arraysData$indexonSc10 === void 0 ? void 0 : _arraysData$indexonSc10.categorySlug, "/post/").concat((_arraysData$indexonSc11 = arraysData[indexonScreen]) === null || _arraysData$indexonSc11 === void 0 ? void 0 : _arraysData$indexonSc11.postSlug)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "fb:pages",
        content: "1453842511589254"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "article:published_time" // content={convertToIST(arraysData[indexonScreen]?.publishedAt)}
        ,
        content: (_arraysData$indexonSc12 = arraysData[indexonScreen]) === null || _arraysData$indexonSc12 === void 0 ? void 0 : _arraysData$indexonSc12.publishedAtIST
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "article:modified_time",
        content: (_arraysData$indexonSc13 = arraysData[indexonScreen]) === null || _arraysData$indexonSc13 === void 0 ? void 0 : _arraysData$indexonSc13.updatedAtIST
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "twitter:title",
        content: (_arraysData$indexonSc14 = arraysData[indexonScreen]) === null || _arraysData$indexonSc14 === void 0 ? void 0 : _arraysData$indexonSc14.title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "twitter:image",
        content: (_arraysData$indexonSc15 = arraysData[indexonScreen]) === null || _arraysData$indexonSc15 === void 0 ? void 0 : _arraysData$indexonSc15.headingImageUrl
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "twitter:site_name",
        content: "The Lallantop"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "twitter:description",
        content: (_arraysData$indexonSc16 = arraysData[indexonScreen]) === null || _arraysData$indexonSc16 === void 0 ? void 0 : _arraysData$indexonSc16.shortText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "twitter:url",
        content: ((_arraysData$indexonSc17 = arraysData[indexonScreen]) === null || _arraysData$indexonSc17 === void 0 ? void 0 : _arraysData$indexonSc17.permalink) || ((_arraysData$indexonSc18 = arraysData[indexonScreen]) === null || _arraysData$indexonSc18 === void 0 ? void 0 : (_arraysData$indexonSc19 = _arraysData$indexonSc18.seoData) === null || _arraysData$indexonSc19 === void 0 ? void 0 : _arraysData$indexonSc19.canonicalURL)
      }), keywords && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "keywords",
        content: "".concat(keywords)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("link", {
        rel: "preconnect",
        crossOrigin: "true",
        href: "https://static.chartbeat.com"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
      title: (_arraysData$indexonSc20 = arraysData[indexonScreen]) === null || _arraysData$indexonSc20 === void 0 ? void 0 : (_arraysData$indexonSc21 = _arraysData$indexonSc20.seoData) === null || _arraysData$indexonSc21 === void 0 ? void 0 : _arraysData$indexonSc21.metaTitle // "" +
      // (arraysData[indexonScreen]?.type === "text" ? " Article" : " Video")
      // arraysData[indexonScreen]?.seoData?.metaTitle + " - The Lallantop"
      ,
      description: (_arraysData$indexonSc22 = arraysData[indexonScreen]) === null || _arraysData$indexonSc22 === void 0 ? void 0 : (_arraysData$indexonSc23 = _arraysData$indexonSc22.seoData) === null || _arraysData$indexonSc23 === void 0 ? void 0 : _arraysData$indexonSc23.metaDescription,
      canonical: ((_arraysData$indexonSc24 = arraysData[indexonScreen]) === null || _arraysData$indexonSc24 === void 0 ? void 0 : _arraysData$indexonSc24.permalink) || ((_arraysData$indexonSc25 = arraysData[indexonScreen]) === null || _arraysData$indexonSc25 === void 0 ? void 0 : (_arraysData$indexonSc26 = _arraysData$indexonSc25.seoData) === null || _arraysData$indexonSc26 === void 0 ? void 0 : _arraysData$indexonSc26.canonicalURL),
      datePublished: (_arraysData$indexonSc27 = arraysData[indexonScreen]) === null || _arraysData$indexonSc27 === void 0 ? void 0 : _arraysData$indexonSc27.publishedAtIST,
      dateModified: (_arraysData$indexonSc28 = arraysData[indexonScreen]) === null || _arraysData$indexonSc28 === void 0 ? void 0 : _arraysData$indexonSc28.updatedAtIST,
      openGraph: {
        url: ((_arraysData$indexonSc29 = arraysData[indexonScreen]) === null || _arraysData$indexonSc29 === void 0 ? void 0 : _arraysData$indexonSc29.permalink) || ((_arraysData$indexonSc30 = arraysData[indexonScreen]) === null || _arraysData$indexonSc30 === void 0 ? void 0 : (_arraysData$indexonSc31 = _arraysData$indexonSc30.seoData) === null || _arraysData$indexonSc31 === void 0 ? void 0 : _arraysData$indexonSc31.canonicalURL),
        title: (_arraysData$indexonSc32 = arraysData[indexonScreen]) === null || _arraysData$indexonSc32 === void 0 ? void 0 : _arraysData$indexonSc32.title,
        description: (_arraysData$indexonSc33 = arraysData[indexonScreen]) === null || _arraysData$indexonSc33 === void 0 ? void 0 : _arraysData$indexonSc33.shortText,
        type: "website",
        images: [{
          url: (_arraysData$indexonSc34 = arraysData[indexonScreen]) === null || _arraysData$indexonSc34 === void 0 ? void 0 : _arraysData$indexonSc34.headingImageUrl,
          alt: (_arraysData$indexonSc35 = arraysData[indexonScreen]) === null || _arraysData$indexonSc35 === void 0 ? void 0 : _arraysData$indexonSc35.imgCaption
        }],
        site_name: "The Lallantop"
      },
      twitter: {
        handle: "@TheLallantop",
        site: "@TheLallantop",
        cardType: "summary_large_image"
      },
      facebook: {
        appId: "574628820637757"
      },
      robotsProps: {
        // maxSnippet: -1,
        maxImagePreview: "large" // maxVideoPreview: -1,

      } // additionalMetaTags={[{
      //   name: 'googlebot',
      //   content:'max-image-preview: standard'
      // },{
      //   name: 'robots',
      //   content:'max-image-preview: large'
      // }]}

    }), pageScrolled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(RecengineWidget, {
      size: size,
      postId: postData === null || postData === void 0 ? void 0 : postData._id
    }), categoryName == 'sports' && masterConfigCT['ChampionsTrophyWidget']['ShowWidgetOnAllSport'] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(WidgetHome, {
        newsData: cricketTopicData,
        scoreData: scoreData,
        pointsData: pointsData,
        table: pointsData.standings.stage1.groups[0],
        size: size
      })
    }), (articlePageBanners === null || articlePageBanners === void 0 ? void 0 : articlePageBanners.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: "checkMobileOrNot ".concat((articlePageBanners === null || articlePageBanners === void 0 ? void 0 : articlePageBanners.length) === 1 ? "stickyArticleBanner" : "", " ").concat((articlePageBanners === null || articlePageBanners === void 0 ? void 0 : articlePageBanners.length) === 1 && !showStickyBanner ? "remove-sticky" : ""),
      style: {
        margin: "5px 6px 0 6px"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(DynamicBanner, {
        list: articlePageBanners,
        type: "msite",
        fromArticlePage: true,
        setShowStickyBanner: setShowStickyBanner,
        showStickyBanner: showStickyBanner,
        page: "article"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_elections_2023_ElectionsWidget__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: "content-wrapper",
      style: {
        minHeight: "250px"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: "container-row content-container",
          children: arraysData.map(function (articleData, index) {
            var _articleData$images, _articleData$contentA, _articleData$contentA2, _articleData$contentA3, _articleData$contentA4, _articleData$contentA5, _articleData$inputAut, _articleData$publishe, _articleData$updatedA, _articleData$publishe2, _articleData$updatedA2, _articleData$contentA6, _articleData$contentA7, _articleData$inputAut2, _bookmarkArticleArray2, _articleData$contentA8, _articleData$inputAut3, _articleData$publishe3, _articleData$updatedA3, _articleData$publishe4, _articleData$updatedA4, _bookmarkArticleArray3, _articleData$topicIte, _articleData$topicIte2, _homePageVideos$entit, _homePageVideos$entit2, _homePageVideos$entit3, _homePageVideos$entit4;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
              className: "infinite articles ".concat(index),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: "container-row py-2 deaktop-header-ad",
                align: "center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h5", {
                  id: "ads",
                  style: {
                    fontSize: "11px",
                    color: "#b7b7b7",
                    textAlign: "center",
                    marginBottom: "0px"
                  },
                  children: "Advertisement"
                }), indexonScreen === index && size.width > 700 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                  id: "div-gpt-ad-1701945163318-0",
                  style: {
                    minWidth: "300px",
                    minHeight: size.width > 700 ? "100px" : "260px",
                    display: "block !important",
                    alignContent: "center",
                    textAlign: "-webkit-center"
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
                    type: "text/javascript",
                    dangerouslySetInnerHTML: {
                      __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})"
                    }
                  })
                })]
              }), router.asPath.includes("show/") ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("ul", {
                className: "breadcrumb aa",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    href: "/",
                    passHref: true,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("i", {
                        className: "icon-cat-home"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                          id: "home",
                          defaultMessage: "\u0939\u094B\u092E"
                        })
                      })]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    href: "/show/all",
                    passHref: true,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                          id: "series",
                          defaultMessage: "\u0936\u094B"
                        })
                      })
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    href: "/show/detail/".concat(query === null || query === void 0 ? void 0 : query.seriesSlug),
                    passHref: true,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                        children: language === "hi" ? postStateData === null || postStateData === void 0 ? void 0 : postStateData.seriesTitleHn : postStateData === null || postStateData === void 0 ? void 0 : postStateData.seriesTitle
                      })
                    })
                  })
                })]
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("ul", {
                className: "breadcrumb-article breadcrumb-article-page",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    href: "/",
                    passHref: true,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("i", {
                        className: "icon-cat-home"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                        children: "Home"
                      })]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    href: "/".concat(mainUrl, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.categorySlug) //query: { categoryId: postStateData?.categoryId },
                    ,
                    passHref: true,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                        children: language === "hi" ? articleData === null || articleData === void 0 ? void 0 : articleData.categoryName : articleData === null || articleData === void 0 ? void 0 : articleData.categoryName
                      })
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                  children: (size === null || size === void 0 ? void 0 : size.width) >= 780 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                    children: language === "hi" ? articleData === null || articleData === void 0 ? void 0 : articleData.englishTitle.substring(0, 100) : articleData === null || articleData === void 0 ? void 0 : articleData.englishTitle.substring(0, 100)
                  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                    children: language === "hi" ? (articleData === null || articleData === void 0 ? void 0 : articleData.englishTitle.substring(0, 30)) + "..." : (articleData === null || articleData === void 0 ? void 0 : articleData.englishTitle.substring(0, 30)) + "..."
                  })
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: fontSize === "small" ? "card-wrapper new-details-small" : fontSize === "large" ? "card-wrapper new-details-large" : "card-wrapper new-details",
                style: {
                  position: "relative"
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                  className: "card-left custom-card-left",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                    className: "card-body post-body",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                      className: fontSize === "small" ? "news-title-small" : fontSize === "large" ? "news-title-large" : "news-title",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h1", {
                        children: articleData === null || articleData === void 0 ? void 0 : articleData.title
                      })
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h2", {
                      children: articleData === null || articleData === void 0 ? void 0 : articleData.shortText
                    }), !!(articleData !== null && articleData !== void 0 && (_articleData$images = articleData.images) !== null && _articleData$images !== void 0 && _articleData$images.length) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                      className: "news-slider",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {
                        fade: true,
                        indicators: false,
                        controls: false,
                        children: articleData.images.map(function (imageLink, index) {
                          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_34__/* ["default"].Item */ .Z.Item, {
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                              className: "image",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                                className: "image-thumb",
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                                  src: imageLink,
                                  width: "810px",
                                  height: "492px",
                                  alt: "Writer pic",
                                  loading: "lazy"
                                })
                              })
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                              className: "slider-caption",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_34__/* ["default"].Caption */ .Z.Caption, {
                                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                  className: "text"
                                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                  className: "indicators",
                                  children: "1/5"
                                })]
                              })
                            })]
                          }, index);
                        })
                      })
                    }), !(size.width > 700) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                      className: "container-row py-2 mobile-header-ad",
                      align: "center" // style={{
                      //   minWidth: "300px",
                      //   minHeight: size.width > 600 ? "110px" : "275px",
                      //   display: "block !important",
                      // }}
                      ,
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                        id: "ads",
                        style: {
                          fontSize: "11px",
                          color: "#b7b7b7",
                          textAlign: "center",
                          marginBottom: "0px"
                        },
                        children: "Advertisement"
                      }), indexonScreen === index && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                        id: "div-gpt-ad-1701946028239-0",
                        style: {
                          minWidth: "300px",
                          minHeight: "260px",
                          display: "block !important",
                          alignContent: "center",
                          textAlign: "-webkit-center"
                        },
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
                          type: "text/javascript",
                          dangerouslySetInnerHTML: {
                            __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
                          }
                        })
                      })]
                    }), (articleData === null || articleData === void 0 ? void 0 : articleData.type) === "text" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(VideoPlayer, {
                      url: articleData,
                      type: articleData === null || articleData === void 0 ? void 0 : articleData.type,
                      image_url: articleData === null || articleData === void 0 ? void 0 : articleData.headingImageUrl,
                      fileLink: (articleData === null || articleData === void 0 ? void 0 : articleData.assetFileLink) + "?width=".concat(isFirstTime ? 210 : size.width < 700 ? 360 : 540),
                      text: articleData === null || articleData === void 0 ? void 0 : articleData.imgAltText,
                      caption: articleData === null || articleData === void 0 ? void 0 : articleData.imgCaption
                    }, articleData === null || articleData === void 0 ? void 0 : articleData._id), (articleData === null || articleData === void 0 ? void 0 : articleData.type) === "video" && !isNaN(aspectRatio) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                      style: aspectRatio <= 1.99 || aspectRatio >= 2.5 ? {
                        minHeight: "222px"
                      } : {
                        minHeight: "221px",
                        margin: "0 -2.5rem"
                      },
                      children: loadPlayer && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(ReactJWPlayer, {
                        playerId: "jw-player-".concat(index + 1),
                        playerScript: "https://cdn.jwplayer.com/libraries/gtSITKWv.js",
                        playlist: [{
                          file: articleData === null || articleData === void 0 ? void 0 : articleData.assetFileLink,
                          image: (articleData === null || articleData === void 0 ? void 0 : articleData.headingImageUrl) + "?width=".concat(isFirstTime ? 150 : aspectRatio >= 2 || aspectRatio < 2.5 ? 360 : 540),
                          title: articleData === null || articleData === void 0 ? void 0 : articleData.title
                        }],
                        isAutoPlay: false,
                        isMuted: false,
                        title: "Sdfd",
                        onPlay: function onPlay() {
                          handleVideoPlay("jw-player-".concat(index + 1));
                          setCurrentPlayer("jw-player-".concat(index + 1)); // console.log("Start video-event");

                          if (typeof window.gtag !== "undefined") {
                            gtag("create", "G-6DCEWMBVGD", "auto");
                            var main_video = {};
                            main_video["send_to"] = "G-6DCEWMBVGD";
                            main_video["eventCategory"] = "Main_Video";
                            main_video["eventLabel"] = "Video Starts";
                            main_video["eventValue"] = "".concat(postData.englishTitle);
                            gtag("event", "Native_Video", main_video);
                          }
                        },
                        onResume: function onResume(event) {
                          handleVideoPlay("jw-player-".concat(index + 1));
                          setCurrentPlayer("jw-player-".concat(index + 1));

                          if (typeof window.gtag !== "undefined") {
                            gtag("create", "G-6DCEWMBVGD", "auto");
                            var main_video = {};
                            main_video["send_to"] = "G-6DCEWMBVGD";
                            main_video["eventCategory"] = "Main_Video";
                            main_video["eventLabel"] = "Video Resumes";
                            main_video["eventValue"] = "".concat(postData.englishTitle);
                            gtag("event", "Native_Video", main_video);
                          }
                        },
                        onPause: function onPause() {
                          // console.log("Pause video-event");
                          if (typeof window.gtag !== "undefined") {
                            gtag("create", "G-6DCEWMBVGD", "auto");
                            var main_video = {};
                            main_video["send_to"] = "G-6DCEWMBVGD";
                            main_video["eventCategory"] = "Main_Video";
                            main_video["eventLabel"] = "Video Paused";
                            main_video["eventValue"] = "".concat(postData.englishTitle);
                            gtag("event", "Native_Video", main_video);
                          } // if (typeof window.ga !== "undefined") {
                          //   ga("create", "G-6DCEWMBVGD", "auto");
                          //   ga("send", "event", {
                          //     eventCategory: "JW_Video",
                          //     eventAction: "Paused",
                          //     eventLabel: "title",
                          //     eventValue:
                          //       "https://www.thelallantop.com/",
                          //   });
                          // }

                        },
                        onSeek: function onSeek(event) {
                          // console.log(
                          //   "Seeking video-event ",
                          //   event.offset
                          // );
                          if (typeof window.gtag !== "undefined") {
                            gtag("create", "G-6DCEWMBVGD", "auto");
                            var main_video = {};
                            main_video["send_to"] = "G-6DCEWMBVGD";
                            main_video["eventCategory"] = "Main_Video";
                            main_video["eventLabel"] = "Video Seeked";
                            main_video["eventValue"] = "Seeked_to_".concat(event.offset);
                            gtag("event", "Native_Video", main_video);
                          }
                        },
                        onTwentyFivePercent: function onTwentyFivePercent() {
                          // console.log("Two Five video-event");
                          if (typeof window.gtag !== "undefined") {
                            gtag("create", "G-6DCEWMBVGD", "auto");
                            var main_video = {};
                            main_video["send_to"] = "G-6DCEWMBVGD";
                            main_video["eventCategory"] = "Main_Video";
                            main_video["eventLabel"] = "Video Duration";
                            main_video["eventValue"] = "Duration_25%";
                            gtag("event", "Native_Video", main_video);
                          }
                        } // setStreamingPercent((prevState) => ({
                        //   ...prevState,
                        //   percent25: true,
                        // }))
                        // }
                        // }
                        ,
                        onFiftyPercent: function onFiftyPercent() {
                          // console.log("Fifty percent video-event");
                          if (typeof window.gtag !== "undefined") {
                            gtag("create", "G-6DCEWMBVGD", "auto");
                            var main_video = {};
                            main_video["send_to"] = "G-6DCEWMBVGD";
                            main_video["eventCategory"] = "Main_Video";
                            main_video["eventLabel"] = "Video Duration";
                            main_video["eventValue"] = "Duration_50%";
                            gtag("event", "Native_Video", main_video);
                          }
                        } // setStreamingPercent((prevState) => ({
                        //   ...prevState,
                        //   percent50: true,
                        // }))
                        ,
                        onSeventyFivePercent: function onSeventyFivePercent() {
                          // console.log("Seventxy Five video-event");
                          if (typeof window.gtag !== "undefined") {
                            gtag("create", "G-6DCEWMBVGD", "auto");
                            var main_video = {};
                            main_video["send_to"] = "G-6DCEWMBVGD";
                            main_video["eventCategory"] = "Main_Video";
                            main_video["eventLabel"] = "Video Duration";
                            main_video["eventValue"] = "Duration_75%";
                            gtag("event", "Native_Video", main_video);
                          } // setStreamingPercent((prevState) => ({
                          //   ...prevState,
                          //   percent75: true,
                          // }))

                        },
                        onOneHundredPercent: function onOneHundredPercent() {
                          // console.log("Hundred video-event");
                          if (typeof window.gtag !== "undefined") {
                            gtag("create", "G-6DCEWMBVGD", "auto");
                            var main_video = {};
                            main_video["send_to"] = "G-6DCEWMBVGD";
                            main_video["eventCategory"] = "Main_Video";
                            main_video["eventLabel"] = "Video Duration";
                            main_video["eventValue"] = "Duration_100%";
                            gtag("event", "Native_Video", main_video);
                          }
                        },
                        className: "my-2"
                      })
                    }), (articleData === null || articleData === void 0 ? void 0 : articleData.type) === "audio" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("audio", {
                      controls: true,
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("source", {
                        src: articleData === null || articleData === void 0 ? void 0 : articleData.assetFileLink,
                        type: "audio/mpeg"
                      })
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                      className: fontSize === "small" ? "news-options-small display-block author-box" : fontSize === "large" ? "news-options-large display-block author-box" : "news-options display-block author-box",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                        className: "author-section",
                        style: {
                          display: "flex"
                        },
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                          className: "user user-section",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                            className: "image",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                              className: "image-thumb",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                                src: (articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors) && (articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA = articleData.contentAuthors[0]) === null || _articleData$contentA === void 0 ? void 0 : _articleData$contentA.profileImage) + "?width=60",
                                width: "60",
                                height: "60",
                                alt: "pic",
                                loading: "lazy"
                              })
                            })
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                            className: "user-detail",
                            style: {
                              maxWidth: "100%"
                            },
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                              href: "/authors/".concat((articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors) && (articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA2 = articleData.contentAuthors[0]) === null || _articleData$contentA2 === void 0 ? void 0 : (_articleData$contentA3 = _articleData$contentA2.email) === null || _articleData$contentA3 === void 0 ? void 0 : _articleData$contentA3.split("@")[0])),
                              passHref: true,
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                                style: {
                                  color: "black"
                                },
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                  className: "name second-author-name",
                                  children: (articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors) && (articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA4 = articleData.contentAuthors[0]) === null || _articleData$contentA4 === void 0 ? void 0 : _articleData$contentA4.fullname)
                                })
                              })
                            }), !((articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA5 = articleData.contentAuthors) === null || _articleData$contentA5 === void 0 ? void 0 : _articleData$contentA5.length) > 1 || (articleData === null || articleData === void 0 ? void 0 : (_articleData$inputAut = articleData.inputAuthors) === null || _articleData$inputAut === void 0 ? void 0 : _articleData$inputAut.length) > 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                              className: "date date-fix-overflow",
                              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                                className: "date-desktop",
                                children: (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_13__/* .formatDate */ .p6)(articleData === null || articleData === void 0 ? void 0 : articleData.publishedAt).date
                              }), (articleData === null || articleData === void 0 ? void 0 : (_articleData$publishe = articleData.publishedAt) === null || _articleData$publishe === void 0 ? void 0 : _articleData$publishe.toString()) !== (articleData === null || articleData === void 0 ? void 0 : (_articleData$updatedA = articleData.updatedAt) === null || _articleData$updatedA === void 0 ? void 0 : _articleData$updatedA.toString()) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("span", {
                                className: "date-desktop",
                                children: [" ", " (", language === "hi" ? "अपडेटेड: " : "Updated: ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_13__/* .formatDate */ .p6)(articleData === null || articleData === void 0 ? void 0 : articleData.updatedAt).date, ", ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_13__/* .formatDateIST */ .Pj)(articleData === null || articleData === void 0 ? void 0 : articleData.updatedAt).time, " IST", ")"]
                              }), (articleData === null || articleData === void 0 ? void 0 : (_articleData$publishe2 = articleData.publishedAt) === null || _articleData$publishe2 === void 0 ? void 0 : _articleData$publishe2.toString()) === (articleData === null || articleData === void 0 ? void 0 : (_articleData$updatedA2 = articleData.updatedAt) === null || _articleData$updatedA2 === void 0 ? void 0 : _articleData$updatedA2.toString()) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("span", {
                                className: "date-desktop",
                                children: [" ", " (", language === "hi" ? "पब्लिश्डः: " : "Published: ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_13__/* .formatDateIST */ .Pj)(articleData === null || articleData === void 0 ? void 0 : articleData.publishedAt).time, " IST", ")"]
                              })]
                            })]
                          })]
                        }), (articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA6 = articleData.contentAuthors) === null || _articleData$contentA6 === void 0 ? void 0 : _articleData$contentA6.length) > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                          className: "user user-section",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                            className: "image",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                              className: "image-thumb",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                                src: (articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors) && (articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors[1].profileImage),
                                width: "60",
                                height: "60",
                                alt: "pic",
                                loading: "lazy"
                              })
                            })
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                            className: "user-detail",
                            style: {
                              maxWidth: "100%"
                            },
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                              href: "/authors/".concat(articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors[1].email.split("@")[0]),
                              passHref: true,
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                                style: {
                                  color: "black"
                                },
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                  className: "name second-author-name",
                                  children: articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors[1].fullname
                                })
                              })
                            })
                          })]
                        }), (articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA7 = articleData.contentAuthors) === null || _articleData$contentA7 === void 0 ? void 0 : _articleData$contentA7.length) === 1 && (articleData === null || articleData === void 0 ? void 0 : (_articleData$inputAut2 = articleData.inputAuthors) === null || _articleData$inputAut2 === void 0 ? void 0 : _articleData$inputAut2.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                          className: "user user-section",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                            className: "image",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                              className: "image-thumb",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                                src: "https://www.thelallantop.com/_next/image?url=https%3A%2F%2Fstatic.thelallantop.com%2Fimages%2Fauthor%2F1653057005739_logo.png&w=256&q=75",
                                width: "60",
                                height: "60",
                                alt: "pic",
                                loading: "lazy"
                              })
                            })
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                            className: "user-detail",
                            style: {
                              maxWidth: "inherit"
                            },
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                              className: "name second-author-name",
                              children: articleData === null || articleData === void 0 ? void 0 : articleData.inputAuthors[0]
                            })
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                          className: "options mobile-options d-visible-icons",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_FontSize__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            setFontSize: setFontSize,
                            fontSize: fontSize
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                            className: "btns",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("i", {
                              onClick: function onClick() {
                                handleBookmark((articleData === null || articleData === void 0 ? void 0 : articleData.postId) || (articleData === null || articleData === void 0 ? void 0 : articleData._id), articleData === null || articleData === void 0 ? void 0 : articleData.type, index);
                              },
                              title: "bookmark",
                              style: {
                                fontWeight: "600"
                              },
                              className: "icon-bookmark".concat((_bookmarkArticleArray2 = bookmarkArticleArray[index]) !== null && _bookmarkArticleArray2 !== void 0 && _bookmarkArticleArray2.isBookmarked ? "-fill" : ""),
                              role: "button",
                              "aria-label": "Bookmark Toggle"
                            })
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                            className: "btns",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("i", {
                              onClick: function onClick() {
                                handleShare(articleData);
                              },
                              title: "share",
                              style: {
                                fontWeight: "600",
                                fontSize: "2.1rem"
                              },
                              className: "icon-share",
                              "aria-label": "Share Button",
                              role: "link"
                            })
                          })]
                        })]
                      }), console.log("Video Page data ", articleData), ((articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA8 = articleData.contentAuthors) === null || _articleData$contentA8 === void 0 ? void 0 : _articleData$contentA8.length) > 1 || (articleData === null || articleData === void 0 ? void 0 : (_articleData$inputAut3 = articleData.inputAuthors) === null || _articleData$inputAut3 === void 0 ? void 0 : _articleData$inputAut3.length) > 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                        className: "date date-fix-overflow",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                          className: "date-desktop",
                          children: (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_13__/* .formatDate */ .p6)(articleData === null || articleData === void 0 ? void 0 : articleData.publishedAt).date
                        }), (articleData === null || articleData === void 0 ? void 0 : (_articleData$publishe3 = articleData.publishedAt) === null || _articleData$publishe3 === void 0 ? void 0 : _articleData$publishe3.toString()) !== (articleData === null || articleData === void 0 ? void 0 : (_articleData$updatedA3 = articleData.updatedAt) === null || _articleData$updatedA3 === void 0 ? void 0 : _articleData$updatedA3.toString()) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("span", {
                          className: "date-desktop",
                          children: [" ", " (", language === "hi" ? "अपडेटेड: " : "Updated: ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_13__/* .formatDate */ .p6)(articleData === null || articleData === void 0 ? void 0 : articleData.updatedAt).date, ", ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_13__/* .formatDateIST */ .Pj)(articleData === null || articleData === void 0 ? void 0 : articleData.updatedAt).time, " IST", ")"]
                        }), (articleData === null || articleData === void 0 ? void 0 : (_articleData$publishe4 = articleData.publishedAt) === null || _articleData$publishe4 === void 0 ? void 0 : _articleData$publishe4.toString()) === (articleData === null || articleData === void 0 ? void 0 : (_articleData$updatedA4 = articleData.updatedAt) === null || _articleData$updatedA4 === void 0 ? void 0 : _articleData$updatedA4.toString()) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("span", {
                          className: "date-desktop",
                          children: [" ", " (", language === "hi" ? "पब्लिश्डः: " : "Published: ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_13__/* .formatDateIST */ .Pj)(articleData === null || articleData === void 0 ? void 0 : articleData.publishedAt).time, " IST", ")"]
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                        className: "options mobile-options m-visible-icons",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_FontSize__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                          setFontSize: setFontSize,
                          fontSize: fontSize
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                          className: "btns",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("i", {
                            onClick: function onClick() {
                              handleBookmark((articleData === null || articleData === void 0 ? void 0 : articleData.postId) || (articleData === null || articleData === void 0 ? void 0 : articleData._id), articleData === null || articleData === void 0 ? void 0 : articleData.type, index);
                            },
                            title: "bookmark",
                            style: {
                              fontWeight: "600"
                            },
                            className: "icon-bookmark".concat((_bookmarkArticleArray3 = bookmarkArticleArray[index]) !== null && _bookmarkArticleArray3 !== void 0 && _bookmarkArticleArray3.isBookmarked ? "-fill" : ""),
                            role: "button",
                            "aria-label": "Bookmark Toggle"
                          })
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                          className: "btns",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("i", {
                            onClick: function onClick() {
                              handleShare(articleData);
                            },
                            title: "share",
                            style: {
                              fontWeight: "600",
                              fontSize: "2.1rem"
                            },
                            className: "icon-share",
                            "aria-label": "Share Button",
                            role: "link"
                          })
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                          className: "btns d-flex align-items-center",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                            "aria-label": "Whatsapp Share Button",
                            role: "link",
                            title: "whatsapp",
                            onClick: function onClick() {
                              shareLinkToWhatsApp(articleData);
                            },
                            src: "/assets/images/whatsapp2.png",
                            width: 20,
                            height: 20,
                            alt: "whatsapp share"
                          })
                        })]
                      })]
                    }), pageScrolled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(ArticleHTML, {
                      postData: articleData,
                      postStateData: articleData,
                      isFirstTime: isFirstTime,
                      indexonScreen: indexonScreen,
                      relatedArticles: relatedArticles,
                      articleIndex: index,
                      showMore: showMore[index],
                      handleShowMore: function handleShowMore() {
                        return handleReadMore(index);
                      }
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                      style: showMore[index] ? {
                        display: "block"
                      } : {
                        display: "none"
                      },
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
                        ref: jwRef,
                        style: {
                          marginTop: "10px"
                        },
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("strong", {
                          children: articleData === null || articleData === void 0 ? void 0 : articleData.embedTitle
                        })
                      }), (articleData === null || articleData === void 0 ? void 0 : articleData.embedUrl) && isJWVisible && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                        style: size.width > 700 ? {
                          minHeight: "222px"
                        } : {
                          minHeight: "221px"
                        },
                        children: loadPlayer && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(ReactJWPlayer, {
                          playerId: "jw-player-".concat(index + 1),
                          playerScript: "https://cdn.jwplayer.com/libraries/gtSITKWv.js",
                          onPlay: function onPlay() {
                            handleVideoPlay("jw-player-".concat(index + 1));
                            setCurrentPlayer("jw-player-".concat(index + 1));

                            if (typeof window.gtag !== "undefined") {
                              gtag("create", "G-6DCEWMBVGD", "auto");
                              var main_video = {};
                              main_video["send_to"] = "G-6DCEWMBVGD";
                              main_video["eventCategory"] = "Embed_Video";
                              main_video["eventLabel"] = "Video Starts";
                              main_video["eventValue"] = "".concat(postData.englishTitle);
                              gtag("event", "Embed_Video", main_video);
                            }
                          },
                          onResume: function onResume(event) {
                            handleVideoPlay("jw-player-".concat(index + 1));
                            setCurrentPlayer("jw-player-".concat(index + 1));

                            if (typeof window.gtag !== "undefined") {
                              gtag("create", "G-6DCEWMBVGD", "auto");
                              var main_video = {};
                              main_video["send_to"] = "G-6DCEWMBVGD";
                              main_video["eventCategory"] = "Embed_Video";
                              main_video["eventLabel"] = "Video Resumes";
                              main_video["eventValue"] = "".concat(postData.englishTitle);
                              gtag("event", "Embed_Video", main_video);
                            }
                          },
                          onPause: function onPause() {
                            // console.log("Pause video-event");
                            if (typeof window.gtag !== "undefined") {
                              gtag("create", "G-6DCEWMBVGD", "auto");
                              var main_video = {};
                              main_video["send_to"] = "G-6DCEWMBVGD";
                              main_video["eventCategory"] = "Embed_Video";
                              main_video["eventLabel"] = "Video Paused";
                              main_video["eventValue"] = "".concat(postData.englishTitle);
                              gtag("event", "Embed_Video", main_video);
                            } // if (typeof window.ga !== "undefined") {
                            //   ga("create", "G-6DCEWMBVGD", "auto");
                            //   ga("send", "event", {
                            //     eventCategory: "JW_Video",
                            //     eventAction: "Paused",
                            //     eventLabel: "title",
                            //     eventValue:
                            //       "https://www.thelallantop.com/",
                            //   });
                            // }

                          },
                          onSeek: function onSeek(event) {
                            // console.log(
                            //   "Seeking video-event ",
                            //   event.offset
                            // );
                            if (typeof window.gtag !== "undefined") {
                              gtag("create", "G-6DCEWMBVGD", "auto");
                              var main_video = {};
                              main_video["send_to"] = "G-6DCEWMBVGD";
                              main_video["eventCategory"] = "Embed_Video";
                              main_video["eventLabel"] = "Video Seeked";
                              main_video["eventValue"] = "Seeked_to_".concat(event.offset);
                              gtag("event", "Embed_Video", main_video);
                            }
                          },
                          onTwentyFivePercent: function onTwentyFivePercent() {
                            if (typeof window.gtag !== "undefined") {
                              gtag("create", "G-6DCEWMBVGD", "auto");
                              var main_video = {};
                              main_video["send_to"] = "G-6DCEWMBVGD";
                              main_video["eventCategory"] = "Embed_Video";
                              main_video["eventLabel"] = "Video Duration";
                              main_video["eventValue"] = "Duration_25%";
                              gtag("event", "Embed_Video", main_video);
                            }
                          } // setStreamingPercent((prevState) => ({
                          //   ...prevState,
                          //   percent25: true,
                          // }))
                          // }
                          // }
                          ,
                          onFiftyPercent: function onFiftyPercent() {
                            if (typeof window.gtag !== "undefined") {
                              gtag("create", "G-6DCEWMBVGD", "auto");
                              var main_video = {};
                              main_video["send_to"] = "G-6DCEWMBVGD";
                              main_video["eventCategory"] = "Embed_Video";
                              main_video["eventLabel"] = "Video Duration";
                              main_video["eventValue"] = "Duration_50%";
                              gtag("event", "Embed_Video", main_video);
                            }
                          } // setStreamingPercent((prevState) => ({
                          //   ...prevState,
                          //   percent50: true,
                          // }))
                          ,
                          onSeventyFivePercent: function onSeventyFivePercent() {
                            if (typeof window.gtag !== "undefined") {
                              gtag("create", "G-6DCEWMBVGD", "auto");
                              var main_video = {};
                              main_video["send_to"] = "G-6DCEWMBVGD";
                              main_video["eventCategory"] = "Embed_Video";
                              main_video["eventLabel"] = "Video Duration";
                              main_video["eventValue"] = "Duration_75%";
                              gtag("event", "Embed_Video", main_video);
                            } // setStreamingPercent((prevState) => ({
                            //   ...prevState,
                            //   percent75: true,
                            // }))

                          },
                          onOneHundredPercent: function onOneHundredPercent() {
                            if (typeof window.gtag !== "undefined") {
                              gtag("create", "G-6DCEWMBVGD", "auto");
                              var main_video = {};
                              main_video["send_to"] = "G-6DCEWMBVGD";
                              main_video["eventCategory"] = "Embed_Video";
                              main_video["eventLabel"] = "Video Duration";
                              main_video["eventValue"] = "Duration_100%";
                              gtag("event", "Embed_Video", main_video);
                            }
                          },
                          playlist: [{
                            file: articleData === null || articleData === void 0 ? void 0 : articleData.embedUrl,
                            image: articleData === null || articleData === void 0 ? void 0 : articleData.embedThumbnail
                          }] // file= {postStateData?.embedUrl}
                          ,
                          isAutoPlay: false,
                          isMuted: false,
                          className: "my-2"
                        })
                      })]
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                    style: showMore[index] ? {
                      display: "block"
                    } : {
                      display: "none"
                    },
                    children: [index === 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                      className: "first-article-observer"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(CommentSection, {
                      postData: articleData,
                      postStateData: articleData,
                      ref: ref,
                      language: language,
                      setLoginPrompt: setLoginPrompt,
                      commentIndex: index,
                      isVisible: showMore[index],
                      pageScrolled: pageScrolled
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_faq__WEBPACK_IMPORTED_MODULE_22__["default"], {
                      data: articleData === null || articleData === void 0 ? void 0 : articleData.faqs,
                      title: articleData === null || articleData === void 0 ? void 0 : articleData.title
                    }), (articleData === null || articleData === void 0 ? void 0 : (_articleData$topicIte = articleData.topicItems) === null || _articleData$topicIte === void 0 ? void 0 : _articleData$topicIte.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                      className: "card-body news-hashtag",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h2", {
                        className: "title text-black mb-2",
                        style: {
                          fontWeight: "600"
                        },
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                          id: "topics_mentioned",
                          defaultMessage: "\u0907\u0938 \u092A\u094B\u0938\u094D\u091F \u0938\u0947 \u091C\u0941\u095C\u0947 \u0939\u0941\u090F \u0939\u0948\u0936\u091F\u0948\u0917\u094D\u0938"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("ul", {
                        className: "hashtags-list",
                        children: articleData === null || articleData === void 0 ? void 0 : (_articleData$topicIte2 = articleData.topicItems) === null || _articleData$topicIte2 === void 0 ? void 0 : _articleData$topicIte2.map(function (topic, index) {
                          var _articleData$topicIte3;

                          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                              href: "/topic/".concat(topic === null || topic === void 0 ? void 0 : topic.slug),
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
                                children: [topic === null || topic === void 0 ? void 0 : topic.title, index !== (articleData === null || articleData === void 0 ? void 0 : (_articleData$topicIte3 = articleData.topicItems) === null || _articleData$topicIte3 === void 0 ? void 0 : _articleData$topicIte3.length) - 1 && ","]
                              })
                            })
                          }, index);
                        })
                      })]
                    })]
                  })]
                }), size.width < 700 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                  href: "https://news.google.com/publications/CAAqBwgKMLqg_Qowk8r0Ag",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    target: "_blank",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                      className: "google-news-container",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                        src: "https://static.thelallantop.com/images/post/1690365910228_8b5d7bf402d51d61d72ce54ef1585008f6a45f45.webp?width=50",
                        alt: "google news",
                        width: "34px",
                        height: "34px",
                        className: "google-news-icon",
                        loading: "lazy"
                      })
                    })
                  })
                }), size.width < 700 &&
                /*#__PURE__*/
                // <a href="https://whatsapp.com/channel/0029Va9lDkJDp2QAHxZogJ2r">
                // <a target="_blank">
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                  className: "whatsapp-channel-container",
                  onClick: function onClick() {
                    return shareLinkToWhatsApp();
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                    src: "https://static.thelallantop.com/images/post/1695284130458_whatsapp.webp?width=50",
                    alt: "whatsapp channel",
                    width: "34px",
                    height: "34px",
                    className: "whatsapp-channel-icon",
                    loading: "lazy"
                  })
                }) // </a>
                // </a>
                , size.width < 700 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                  href: "https://share.thelallantop.com/izPo",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                    target: "_blank",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                      className: hideAppButton ? "collapseOpenApp" : "open_app_container",
                      children: hideAppButton ? "" : "Open App"
                    })
                  })
                }), size.width <= 700 ? index === 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                  className: "card-right min-width-ads card-right-ad ",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                    className: "bottom-ads container-row py-2 ",
                    align: "center",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
                      id: "ads",
                      style: {
                        fontSize: "11px",
                        color: "#b7b7b7",
                        marginBottom: "0px"
                      },
                      children: "Advertisement"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                      id: "div-gpt-ad-1701945220410-1",
                      style: {
                        minWidth: "300px",
                        minHeight: "100px",
                        display: "block !important",
                        alignContent: "center",
                        textAlign: "-webkit-center"
                      },
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                          __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})"
                        }
                      })
                    })]
                  })
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                  className: "card-right min-width-ads card-right-ad",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                    className: "container-row py-2",
                    align: "center",
                    style: {
                      minWidth: "300px",
                      minHeight: "250px",
                      display: "block !important" // position: "sticky",
                      // top: "32px",
                      // zIndex: "99",
                      // background: "white",

                    },
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
                      id: "ads",
                      style: {
                        fontSize: "11px",
                        color: "#b7b7b7",
                        marginBottom: "0px"
                      },
                      children: "Advertisement"
                    }), indexonScreen === index && size.width > 700 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                      id: "div-gpt-ad-1701945220410-0",
                      style: {
                        minWidth: "300px",
                        minHeight: "260px",
                        display: "block !important",
                        alignContent: "center",
                        textAlign: "-webkit-center"
                      },
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                          __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-0')})"
                        }
                      })
                    }), indexonScreen === index && size.width < 700 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                      id: "div-gpt-ad-1701946028239-1",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                          __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})"
                        }
                      })
                    })]
                  }), index === 0 && (homePageVideos === null || homePageVideos === void 0 ? void 0 : (_homePageVideos$entit = homePageVideos.entities) === null || _homePageVideos$entit === void 0 ? void 0 : _homePageVideos$entit.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                    className: "chunav-yatra-article",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                      className: "electionYatra-outer-home-article",
                      style: {
                        backgroundColor: homePageVideos === null || homePageVideos === void 0 ? void 0 : homePageVideos.backgroundColor
                      },
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                        className: "electionYatra-header-article",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                            src: homePageVideos === null || homePageVideos === void 0 ? void 0 : homePageVideos.icon,
                            width: "30px",
                            height: "30px",
                            alt: "election-icon",
                            loading: "lazy"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                            style: {
                              marginLeft: "10px",
                              fontSize: "20px"
                            },
                            children: language === "hi" ? homePageVideos === null || homePageVideos === void 0 ? void 0 : homePageVideos.titleHn : homePageVideos === null || homePageVideos === void 0 ? void 0 : homePageVideos.title
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                          className: "election-aurDekhe-article",
                          onClick: function onClick() {
                            return router.push("/topic/chunav-yatra-2024");
                          },
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                            style: {
                              marginRight: "10px"
                            },
                            children: language === "hi" ? "और देखें" : "see more"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                            src: "/assets/images/arrow.png",
                            width: "15px",
                            height: "15px",
                            loading: "lazy"
                          })]
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                        className: "electionYatra-columns-article",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                          href: "".concat(homePageVideos === null || homePageVideos === void 0 ? void 0 : (_homePageVideos$entit2 = homePageVideos.entities[0]) === null || _homePageVideos$entit2 === void 0 ? void 0 : _homePageVideos$entit2.permalink),
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                            className: "electionYatra-second-article election-mobile-article",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                              className: "electionYatra-second-top-article",
                              style: {
                                position: "relative"
                              },
                              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                                src: homePageVideos === null || homePageVideos === void 0 ? void 0 : (_homePageVideos$entit3 = homePageVideos.entities[0]) === null || _homePageVideos$entit3 === void 0 ? void 0 : _homePageVideos$entit3.headingImageUrl,
                                loading: "lazy"
                              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("i", {
                                className: "icon-play-circle",
                                width: "500px",
                                height: "500px",
                                style: {
                                  color: "white",
                                  position: "absolute",
                                  left: "2px",
                                  bottom: "-5px",
                                  width: "500px"
                                }
                              })]
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                              className: "electionYatra-second-bottom-article",
                              style: {
                                fontSize: "17px"
                              },
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h2", {
                                children: homePageVideos === null || homePageVideos === void 0 ? void 0 : (_homePageVideos$entit4 = homePageVideos.entities[0]) === null || _homePageVideos$entit4 === void 0 ? void 0 : _homePageVideos$entit4.title
                              })
                            })]
                          })
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                          style: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                          },
                          children: homePageVideos === null || homePageVideos === void 0 ? void 0 : homePageVideos.entities.slice(1).map(function (x, index) {
                            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                              href: "".concat(x === null || x === void 0 ? void 0 : x.permalink),
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                className: "electionYatra-first-article",
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                                  className: "electionYatra-first-div-article",
                                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                                    style: {
                                      flex: "0 0 40%",
                                      position: "relative",
                                      justifyContent: "center",
                                      alignContent: "center",
                                      alignItems: "center"
                                    },
                                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                                      src: x === null || x === void 0 ? void 0 : x.headingImageUrl,
                                      loading: "lazy" // width="150px"
                                      // height="66px"

                                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("i", {
                                      className: "icon-play-circle",
                                      style: {
                                        color: "white",
                                        position: "absolute",
                                        left: "2px",
                                        bottom: "-5px"
                                      }
                                    })]
                                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                                    className: "electionYatra-first-div-right-article",
                                    style: {
                                      flex: "0 0 60%"
                                    },
                                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                        style: {
                                          overflow: "hidden"
                                        },
                                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                          style: {
                                            display: "-webkit-box",
                                            lineHeight: "20px",
                                            WebkitLineClamp: "3",
                                            WebkitBoxOrient: "vertical",
                                            fontSize: "16px"
                                          },
                                          className: "chunav-yatra-small-title-article",
                                          children: x === null || x === void 0 ? void 0 : x.title
                                        })
                                      })
                                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                                      style: {
                                        display: "flex",
                                        gap: "1rem"
                                      }
                                    })]
                                  })]
                                })
                              })
                            }, index);
                          })
                        })]
                      })]
                    })
                  }), indexonScreen === index && index === 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                    align: "center",
                    style: {
                      minWidth: "300px",
                      minHeight: "250px",
                      display: "block !important" // position: "sticky",
                      // top: "32px",
                      // zIndex: "99",
                      // background: "white",

                    },
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                      className: "container-row py-2",
                      align: "center",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
                        id: "ads",
                        style: {
                          fontSize: "11px",
                          color: "#b7b7b7",
                          marginBottom: "0px"
                        },
                        children: "Advertisement-3"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                        id: "div-gpt-ad-1701945864013-0",
                        style: {
                          minWidth: "300px",
                          minHeight: "260px",
                          display: "block !important",
                          alignContent: "center",
                          textAlign: "-webkit-center"
                        },
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
                          type: "text/javascript",
                          dangerouslySetInnerHTML: {
                            __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945864013-0')})"
                          }
                        })
                      })]
                    })
                  })]
                })]
              }), index <= 3 && arraysData.length > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                separator: "",
                className: "amp-next-page-default-separator",
                tabIndex: "0",
                children: [" ", "Next ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                  className: "triangle_down",
                  children: " "
                }), " "]
              })]
            }, index);
          })
        })
      }), pageScrolled && !!((_trendingData$entitie = trendingData.entities) !== null && _trendingData$entitie !== void 0 && _trendingData$entitie.length) > 0 && size.width < 700 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        style: {
          paddingTop: "20px",
          background: "white"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(TrendingToday, {
          data: trendingData.entities
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
        align: "center",
        style: {
          marginTop: "1rem"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
            id: "ads",
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              marginBottom: "0px"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            id: size.width > 700 ? "div-gpt-ad-1701945220410-3" : "div-gpt-ad-1701946028239-3",
            style: {
              minWidth: "300px",
              minHeight: size.width > 700 ? "100px" : "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: size.width > 700 ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-3')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-3')})"
              }
            })
          })]
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      id: "taboola-below-article-thumbnails"
    }), loginPrompt && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(CommentPopup, {
      showModal: loginPrompt,
      onClose: function onClose() {
        return setLoginPrompt(false);
      }
    }), loginShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(CustomPopup, {
      showModal: loginShow,
      onClose: function onClose() {
        return setLoginShow(false);
      }
    }), openShareModal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(SharePopup, {
      openShareModal: openShareModal,
      setOpenShareModal: setOpenShareModal
    }), !isFirstTime && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_7___default()), {
      id: "taboola",
      children: "\n            window._taboola = window._taboola || [];\n            _taboola.push({article:'auto'});\n            !function (e, f, u, i) {\n            if (!document.getElementById(i)){\n            e.async = 1;\n            e.src = u;\n            e.id = i;\n            f.parentNode.insertBefore(e, f);\n            }\n            }(document.createElement('script'),\n            document.getElementsByTagName('script')[0],\n            '//cdn.taboola.com/libtrc/indiatoday-thelallantop/loader.js',\n            'tb_loader_script');\n            if(window.performance && typeof window.performance.mark == 'function')\n            {window.performance.mark('tbl_ic');}\n            "
    }), router.asPath.includes("show/") ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
      id: "my-script-show",
      type: "application/ld+json",
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [{
            "@type": "ListItem",
            position: 1,
            item: {
              name: "शो",
              "@id": "".concat("https://www.thelallantop.com/", "show/all")
            }
          }, {
            "@type": "ListItem",
            position: 2,
            item: {
              name: "".concat(query === null || query === void 0 ? void 0 : query.seriesSlug),
              "@id": "".concat("https://www.thelallantop.com/", "show/detail/").concat(query === null || query === void 0 ? void 0 : query.seriesSlug)
            }
          }]
        })
      }
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
      id: "my-script-detail",
      type: "application/ld+json",
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [{
            "@type": "ListItem",
            position: 1,
            item: {
              "@id": "".concat("https://www.thelallantop.com/"),
              name: "".concat(language === "hi" ? "होम" : "Home")
            }
          }, {
            "@type": "ListItem",
            position: 2,
            item: {
              name: "".concat(language === "hi" ? postData === null || postData === void 0 ? void 0 : postData.categoryNameHn : postData === null || postData === void 0 ? void 0 : postData.categoryName),
              "@id": "".concat("https://www.thelallantop.com/").concat(mainUrl, "/").concat(postData === null || postData === void 0 ? void 0 : postData.categorySlug)
            }
          }, {
            "@type": "ListItem",
            position: 3,
            item: {
              name: "".concat(postData === null || postData === void 0 ? void 0 : postData.englishTitle),
              "@id": "".concat(postData === null || postData === void 0 ? void 0 : postData.permalink)
            }
          }]
        })
      }
    }), postData && (postData === null || postData === void 0 ? void 0 : postData.type) === "text" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
        id: "my-script2",
        type: "application/ld+json",
        defer: true,
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": "".concat(postData !== null && postData !== void 0 && postData.permalink ? postData === null || postData === void 0 ? void 0 : postData.permalink : "")
            },
            headline: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData = postData.seoData) === null || _postData$seoData === void 0 ? void 0 : _postData$seoData.metaTitle),
            description: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData2 = postData.seoData) === null || _postData$seoData2 === void 0 ? void 0 : _postData$seoData2.metaDescription),
            inLanguage: "hi",
            articleBody: "".concat(postData === null || postData === void 0 ? void 0 : postData.articleHTMLPlainText),
            keywords: "".concat(keywords ? keywords : ""),
            image: {
              "@type": "ImageObject",
              height: 720,
              width: 1280,
              url: "".concat(postData !== null && postData !== void 0 && postData.headingImageUrl ? postData === null || postData === void 0 ? void 0 : postData.headingImageUrl : "")
            },
            datePublished: "".concat(postData !== null && postData !== void 0 && postData.publishedAt ? postData === null || postData === void 0 ? void 0 : postData.publishedAtIST : ""),
            dateModified: "".concat(postData !== null && postData !== void 0 && postData.updatedAt ? postData === null || postData === void 0 ? void 0 : postData.updatedAtIST : ""),
            // articleBody: `${}`,
            author: {
              "@type": "Person",
              name: "".concat(postData !== null && postData !== void 0 && postData.createdByName ? postData === null || postData === void 0 ? void 0 : postData.createdByName : ""),
              url: "".concat("https://www.thelallantop.com/", "authors/").concat(authorName)
            },
            publisher: {
              "@type": "Organization",
              name: "The Lallantop",
              url: "https://www.thelallantop.com/",
              logo: {
                "@type": "ImageObject",
                url: "https://www.thelallantop.com/assets/images/lallatop-logo.svg",
                height: 60,
                width: 600
              }
            }
          })
        }
      })
    }) : postData && (postData === null || postData === void 0 ? void 0 : postData.type) === "video" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
      id: "my-script2",
      type: "application/ld+json",
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "VideoObject",
          name: "".concat(postData !== null && postData !== void 0 && postData.title ? postData === null || postData === void 0 ? void 0 : postData.title : ""),
          headline: "".concat(postData !== null && postData !== void 0 && (_postData$seoData3 = postData.seoData) !== null && _postData$seoData3 !== void 0 && _postData$seoData3.metaTitle ? postData === null || postData === void 0 ? void 0 : (_postData$seoData4 = postData.seoData) === null || _postData$seoData4 === void 0 ? void 0 : _postData$seoData4.metaTitle : ""),
          description: "".concat(postData !== null && postData !== void 0 && (_postData$seoData5 = postData.seoData) !== null && _postData$seoData5 !== void 0 && _postData$seoData5.metaDescription ? postData === null || postData === void 0 ? void 0 : (_postData$seoData6 = postData.seoData) === null || _postData$seoData6 === void 0 ? void 0 : _postData$seoData6.metaDescription : ""),
          url: "".concat(postData !== null && postData !== void 0 && postData.permalink ? postData === null || postData === void 0 ? void 0 : postData.permalink : ""),
          datePublished: "".concat(postData !== null && postData !== void 0 && postData.publishedAt ? postData === null || postData === void 0 ? void 0 : postData.publishedAtIST : ""),
          dateModified: "".concat(postData !== null && postData !== void 0 && postData.updatedAt ? postData === null || postData === void 0 ? void 0 : postData.updatedAtIST : ""),
          uploadDate: "".concat(postData !== null && postData !== void 0 && postData.publishedAt ? postData === null || postData === void 0 ? void 0 : postData.publishedAtIST : ""),
          keywords: "".concat(keywords ? keywords : ""),
          thumbnailUrl: "".concat(postData !== null && postData !== void 0 && postData.headingImageUrl ? postData === null || postData === void 0 ? void 0 : postData.headingImageUrl : "https://static.thelallantop.com/images/post/1693311123087_llt-default-backdrop.webp"),
          contentUrl: "".concat(postData !== null && postData !== void 0 && postData.assetFileLink ? postData !== null && postData !== void 0 && postData.assetFileLink.includes(".m3u8") ? postData === null || postData === void 0 ? void 0 : postData.assetFileLink.replace(".m3u8", ".mp4") : postData === null || postData === void 0 ? void 0 : postData.assetFileLink : ""),
          embedUrl: "".concat(postData !== null && postData !== void 0 && postData.assetFileLink ? postData !== null && postData !== void 0 && postData.assetFileLink.includes(".m3u8") ? postData === null || postData === void 0 ? void 0 : postData.assetFileLink.replace(".m3u8", ".mp4") : postData === null || postData === void 0 ? void 0 : postData.assetFileLink : ""),
          duration: "".concat(postData !== null && postData !== void 0 && postData.duration ? postData === null || postData === void 0 ? void 0 : postData.duration : ""),
          author: {
            "@type": "Person",
            name: "".concat(postData !== null && postData !== void 0 && postData.createdByName ? postData === null || postData === void 0 ? void 0 : postData.createdByName : ""),
            url: "".concat("https://www.thelallantop.com/", "authors/").concat(authorName)
          },
          publisher: {
            "@type": "Organization",
            name: "Lallantop",
            logo: {
              "@type": "ImageObject",
              url: "https://www.thelallantop.com/assets/images/lallatop-logo.svg",
              height: 60,
              width: 600
            }
          },
          potentialAction: {
            "@type": "SeekToAction",
            target: {
              "@type": "EntryPoint",
              urlTemplate: "".concat(postData !== null && postData !== void 0 && postData.permalink ? (postData === null || postData === void 0 ? void 0 : postData.permalink) + "?t={seek_to_second_number}" : "")
            },
            "startOffset-input": {
              "@type": "PropertyValueSpecification",
              valueRequired: "http://schema.org/True",
              valueName: "seek_to_second_number"
            }
          }
        })
      }
    }) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
      type: "application/ld+json",
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfilePage",
          mainEntity: {
            "@type": "Person",
            "@id": "".concat("https://www.thelallantop.com/", "authors/").concat(postData === null || postData === void 0 ? void 0 : postData.contentAuthors[0].email.split("@")[0]),
            name: "".concat(postData === null || postData === void 0 ? void 0 : postData.contentAuthors[0].fullname)
          },
          hasPart: {
            "@type": "Article",
            headline: "".concat(postData === null || postData === void 0 ? void 0 : postData.title),
            url: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData7 = postData.seoData) === null || _postData$seoData7 === void 0 ? void 0 : _postData$seoData7.canonicalURL),
            datePublished: "".concat(postData === null || postData === void 0 ? void 0 : postData.publishedAt),
            author: {
              "@type": "Person",
              "@id": "".concat("https://www.thelallantop.com/", "authors/").concat(postData === null || postData === void 0 ? void 0 : postData.contentAuthors[0].email.split("@")[0]),
              name: "".concat(postData === null || postData === void 0 ? void 0 : postData.contentAuthors[0].fullname)
            }
          }
        })
      }
    }), (postData === null || postData === void 0 ? void 0 : (_postData$additionalS2 = postData.additionalSchemas) === null || _postData$additionalS2 === void 0 ? void 0 : _postData$additionalS2.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
      id: "my-script-movie",
      type: "application/ld+json",
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(postData === null || postData === void 0 ? void 0 : (_postData$additionalS3 = postData.additionalSchemas) === null || _postData$additionalS3 === void 0 ? void 0 : _postData$additionalS3[0])
      }
    }), router.asPath.includes("/factcheck/") && (postData === null || postData === void 0 ? void 0 : postData.itemReviewed) !== "" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
      id: "my-script2",
      type: "application/ld+json",
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ClaimReview",
          url: "".concat(postData === null || postData === void 0 ? void 0 : postData.permalink),
          claimReviewed: "".concat(postData === null || postData === void 0 ? void 0 : postData.claimReviewed),
          itemReviewed: {
            "@type": "Claim",
            author: {
              "@type": "Organization",
              name: "".concat(postData === null || postData === void 0 ? void 0 : postData.claimMakerName),
              sameAs: "".concat(postData === null || postData === void 0 ? void 0 : postData.itemReviewed)
            },
            datePublished: "".concat(postData === null || postData === void 0 ? void 0 : postData.claimDatePublished.slice(0, 10)),
            appearance: {
              "@type": "OpinionNewsArticle",
              url: "".concat(postData === null || postData === void 0 ? void 0 : postData.permalink),
              headline: "".concat(postData === null || postData === void 0 ? void 0 : postData.title),
              datePublished: "".concat(postData === null || postData === void 0 ? void 0 : postData.publishedAtIST),
              author: {
                "@type": "Person",
                name: "".concat(postData === null || postData === void 0 ? void 0 : postData.createdByName)
              },
              image: "".concat(postData === null || postData === void 0 ? void 0 : postData.headingImageUrl),
              publisher: {
                "@type": "Organization",
                name: "The Lallantop",
                logo: {
                  "@type": "ImageObject",
                  url: "https://static.thelallantop.com/images/post/1695637095493_lallantop-logo_(1).webp"
                }
              }
            }
          },
          author: {
            "@type": "Organization",
            name: "The Lallantop"
          },
          reviewRating: {
            "@type": "Rating",
            ratingValue: "".concat(postData === null || postData === void 0 ? void 0 : postData.ratingValue),
            bestRating: "5",
            worstRating: "1",
            alternateName: "".concat(postData === null || postData === void 0 ? void 0 : postData.ratingAlternateName)
          }
        })
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NewsDetailUpdated);

/***/ }),

/***/ 69502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var OPTIONS = {
  root: null,
  rootMargin: "0px 0px 0px 0px",
  threshold: 0
};

var useIsVisible = function useIsVisible(elementRef) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (elementRef.current) {
      var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(elementRef.current);
          }
        });
      }, OPTIONS);
      observer.observe(elementRef.current);
    }
  }, [elementRef]);
  return isVisible;
};

/* harmony default export */ __webpack_exports__["Z"] = (useIsVisible);

/***/ }),

/***/ 18945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83977);

var firebaseConfig = {
  apiKey: "AIzaSyA43bFX7ueF-JM0g-weOR0HxqDuQRkXydg",
  authDomain: "thelallantop-5296b.firebaseapp.com",
  databaseURL: "https://thelallantop-5296b.firebaseio.com",
  projectId: "thelallantop-5296b",
  storageBucket: "thelallantop-5296b.appspot.com",
  messagingSenderId: "928164060644",
  appId: "1:928164060644:web:7490092b73d4b3f714bbf1",
  measurementId: "G-L0B4Q7N010"
}; // const firebaseConfig = {
//   apiKey: "AIzaSyBd9I1B7T3yq5xXY5HoU69k1OIcGSBbnHE",
//   authDomain: "lallantop-dev-c5e4c.firebaseapp.com",
//   databaseURL: "https://lallantop-dev-c5e4c-default-rtdb.firebaseio.com",
//   projectId: "lallantop-dev-c5e4c",
//   storageBucket: "lallantop-dev-c5e4c.appspot.com",
//   messagingSenderId: "606538662701",
//   appId: "1:606538662701:web:b9fd13f9130e72f8f689a4",
//   measurementId: "G-KGFH4PGD46"
// };

var app = (0,firebase_app__WEBPACK_IMPORTED_MODULE_0__/* .initializeApp */ .ZF)(firebaseConfig, "appcheck");
/* harmony default export */ __webpack_exports__["Z"] = (app);

/***/ }),

/***/ 15763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Carousel; }
});

// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(78146);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useUpdateEffect.js


/**
 * Runs an effect only when the dependencies have changed, skipping the
 * initial "on mount" run. Caution, if the dependency list never changes,
 * the effect is **never run**
 *
 * ```ts
 *  const ref = useRef<HTMLInput>(null);
 *
 *  // focuses an element only if the focus changes, and not on mount
 *  useUpdateEffect(() => {
 *    const element = ref.current?.children[focusedIdx] as HTMLElement
 *
 *    element?.focus()
 *
 *  }, [focusedIndex])
 * ```
 * @param effect An effect to run on mount
 *
 * @category effects
 */
function useUpdateEffect(fn, deps) {
  const isFirst = (0,react.useRef)(true);
  (0,react.useEffect)(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    return fn();
  }, deps);
}
/* harmony default export */ var esm_useUpdateEffect = (useUpdateEffect);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCommittedRef.js
var useCommittedRef = __webpack_require__(92029);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMounted.js


/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */
function useMounted() {
  const mounted = (0,react.useRef)(true);
  const isMounted = (0,react.useRef)(() => mounted.current);
  (0,react.useEffect)(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useWillUnmount.js + 1 modules
var useWillUnmount = __webpack_require__(76852);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useTimeout.js




/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */
const MAX_DELAY_MS = 2 ** 31 - 1;
function setChainedTimeout(handleRef, fn, timeoutAtMs) {
  const delayMs = timeoutAtMs - Date.now();
  handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(() => setChainedTimeout(handleRef, fn, timeoutAtMs), MAX_DELAY_MS);
}

/**
 * Returns a controller object for setting a timeout that is properly cleaned up
 * once the component unmounts. New timeouts cancel and replace existing ones.
 *
 *
 *
 * ```tsx
 * const { set, clear } = useTimeout();
 * const [hello, showHello] = useState(false);
 * //Display hello after 5 seconds
 * set(() => showHello(true), 5000);
 * return (
 *   <div className="App">
 *     {hello ? <h3>Hello</h3> : null}
 *   </div>
 * );
 * ```
 */
function useTimeout() {
  const isMounted = useMounted();

  // types are confused between node and web here IDK
  const handleRef = (0,react.useRef)();
  (0,useWillUnmount/* default */.Z)(() => clearTimeout(handleRef.current));
  return (0,react.useMemo)(() => {
    const clear = () => clearTimeout(handleRef.current);
    function set(fn, delayMs = 0) {
      if (!isMounted()) return;
      clear();
      if (delayMs <= MAX_DELAY_MS) {
        // For simplicity, if the timeout is short, just set a normal timeout.
        handleRef.current = setTimeout(fn, delayMs);
      } else {
        setChainedTimeout(handleRef, fn, Date.now() + delayMs);
      }
    }
    return {
      set,
      clear,
      handleRef
    };
  }, []);
}
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Anchor.js + 8 modules
var Anchor = __webpack_require__(24079);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CarouselCaption.js
"use client";





const CarouselCaption = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'carousel-caption');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
CarouselCaption.displayName = 'CarouselCaption';
/* harmony default export */ var esm_CarouselCaption = (CarouselCaption);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CarouselItem.js
var CarouselItem = __webpack_require__(91322);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ElementChildren.js
var ElementChildren = __webpack_require__(53439);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/transitionEndListener.js
var transitionEndListener = __webpack_require__(93825);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/triggerBrowserReflow.js
var triggerBrowserReflow = __webpack_require__(34509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/TransitionWrapper.js + 1 modules
var TransitionWrapper = __webpack_require__(32785);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Carousel.js
"use client";




















const SWIPE_THRESHOLD = 40;
function isVisible(element) {
  if (!element || !element.style || !element.parentNode || !element.parentNode.style) {
    return false;
  }
  const elementStyle = getComputedStyle(element);
  return elementStyle.display !== 'none' && elementStyle.visibility !== 'hidden' && getComputedStyle(element.parentNode).display !== 'none';
}
const Carousel = /*#__PURE__*/react.forwardRef(({
  defaultActiveIndex = 0,
  ...uncontrolledProps
}, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    bsPrefix,
    slide = true,
    fade = false,
    controls = true,
    indicators = true,
    indicatorLabels = [],
    activeIndex,
    onSelect,
    onSlide,
    onSlid,
    interval = 5000,
    keyboard = true,
    onKeyDown,
    pause = 'hover',
    onMouseOver,
    onMouseOut,
    wrap = true,
    touch = true,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    prevIcon = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      "aria-hidden": "true",
      className: "carousel-control-prev-icon"
    }),
    prevLabel = 'Previous',
    nextIcon = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      "aria-hidden": "true",
      className: "carousel-control-next-icon"
    }),
    nextLabel = 'Next',
    variant,
    className,
    children,
    ...props
  } = (0,esm/* useUncontrolled */.Ch)({
    defaultActiveIndex,
    ...uncontrolledProps
  }, {
    activeIndex: 'onSelect'
  });
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'carousel');
  const isRTL = (0,ThemeProvider/* useIsRTL */.SC)();
  const nextDirectionRef = (0,react.useRef)(null);
  const [direction, setDirection] = (0,react.useState)('next');
  const [paused, setPaused] = (0,react.useState)(false);
  const [isSliding, setIsSliding] = (0,react.useState)(false);
  const [renderedActiveIndex, setRenderedActiveIndex] = (0,react.useState)(activeIndex || 0);
  (0,react.useEffect)(() => {
    if (!isSliding && activeIndex !== renderedActiveIndex) {
      if (nextDirectionRef.current) {
        setDirection(nextDirectionRef.current);
      } else {
        setDirection((activeIndex || 0) > renderedActiveIndex ? 'next' : 'prev');
      }
      if (slide) {
        setIsSliding(true);
      }
      setRenderedActiveIndex(activeIndex || 0);
    }
  }, [activeIndex, isSliding, renderedActiveIndex, slide]);
  (0,react.useEffect)(() => {
    if (nextDirectionRef.current) {
      nextDirectionRef.current = null;
    }
  });
  let numChildren = 0;
  let activeChildInterval;

  // Iterate to grab all of the children's interval values
  // (and count them, too)
  (0,ElementChildren/* forEach */.Ed)(children, (child, index) => {
    ++numChildren;
    if (index === activeIndex) {
      activeChildInterval = child.props.interval;
    }
  });
  const activeChildIntervalRef = (0,useCommittedRef/* default */.Z)(activeChildInterval);
  const prev = (0,react.useCallback)(event => {
    if (isSliding) {
      return;
    }
    let nextActiveIndex = renderedActiveIndex - 1;
    if (nextActiveIndex < 0) {
      if (!wrap) {
        return;
      }
      nextActiveIndex = numChildren - 1;
    }
    nextDirectionRef.current = 'prev';
    onSelect == null || onSelect(nextActiveIndex, event);
  }, [isSliding, renderedActiveIndex, onSelect, wrap, numChildren]);

  // This is used in the setInterval, so it should not invalidate.
  const next = (0,useEventCallback/* default */.Z)(event => {
    if (isSliding) {
      return;
    }
    let nextActiveIndex = renderedActiveIndex + 1;
    if (nextActiveIndex >= numChildren) {
      if (!wrap) {
        return;
      }
      nextActiveIndex = 0;
    }
    nextDirectionRef.current = 'next';
    onSelect == null || onSelect(nextActiveIndex, event);
  });
  const elementRef = (0,react.useRef)();
  (0,react.useImperativeHandle)(ref, () => ({
    element: elementRef.current,
    prev,
    next
  }));

  // This is used in the setInterval, so it should not invalidate.
  const nextWhenVisible = (0,useEventCallback/* default */.Z)(() => {
    if (!document.hidden && isVisible(elementRef.current)) {
      if (isRTL) {
        prev();
      } else {
        next();
      }
    }
  });
  const slideDirection = direction === 'next' ? 'start' : 'end';
  esm_useUpdateEffect(() => {
    if (slide) {
      // These callbacks will be handled by the <Transition> callbacks.
      return;
    }
    onSlide == null || onSlide(renderedActiveIndex, slideDirection);
    onSlid == null || onSlid(renderedActiveIndex, slideDirection);
  }, [renderedActiveIndex]);
  const orderClassName = `${prefix}-item-${direction}`;
  const directionalClassName = `${prefix}-item-${slideDirection}`;
  const handleEnter = (0,react.useCallback)(node => {
    (0,triggerBrowserReflow/* default */.Z)(node);
    onSlide == null || onSlide(renderedActiveIndex, slideDirection);
  }, [onSlide, renderedActiveIndex, slideDirection]);
  const handleEntered = (0,react.useCallback)(() => {
    setIsSliding(false);
    onSlid == null || onSlid(renderedActiveIndex, slideDirection);
  }, [onSlid, renderedActiveIndex, slideDirection]);
  const handleKeyDown = (0,react.useCallback)(event => {
    if (keyboard && !/input|textarea/i.test(event.target.tagName)) {
      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          if (isRTL) {
            next(event);
          } else {
            prev(event);
          }
          return;
        case 'ArrowRight':
          event.preventDefault();
          if (isRTL) {
            prev(event);
          } else {
            next(event);
          }
          return;
        default:
      }
    }
    onKeyDown == null || onKeyDown(event);
  }, [keyboard, onKeyDown, prev, next, isRTL]);
  const handleMouseOver = (0,react.useCallback)(event => {
    if (pause === 'hover') {
      setPaused(true);
    }
    onMouseOver == null || onMouseOver(event);
  }, [pause, onMouseOver]);
  const handleMouseOut = (0,react.useCallback)(event => {
    setPaused(false);
    onMouseOut == null || onMouseOut(event);
  }, [onMouseOut]);
  const touchStartXRef = (0,react.useRef)(0);
  const touchDeltaXRef = (0,react.useRef)(0);
  const touchUnpauseTimeout = useTimeout();
  const handleTouchStart = (0,react.useCallback)(event => {
    touchStartXRef.current = event.touches[0].clientX;
    touchDeltaXRef.current = 0;
    if (pause === 'hover') {
      setPaused(true);
    }
    onTouchStart == null || onTouchStart(event);
  }, [pause, onTouchStart]);
  const handleTouchMove = (0,react.useCallback)(event => {
    if (event.touches && event.touches.length > 1) {
      touchDeltaXRef.current = 0;
    } else {
      touchDeltaXRef.current = event.touches[0].clientX - touchStartXRef.current;
    }
    onTouchMove == null || onTouchMove(event);
  }, [onTouchMove]);
  const handleTouchEnd = (0,react.useCallback)(event => {
    if (touch) {
      const touchDeltaX = touchDeltaXRef.current;
      if (Math.abs(touchDeltaX) > SWIPE_THRESHOLD) {
        if (touchDeltaX > 0) {
          prev(event);
        } else {
          next(event);
        }
      }
    }
    if (pause === 'hover') {
      touchUnpauseTimeout.set(() => {
        setPaused(false);
      }, interval || undefined);
    }
    onTouchEnd == null || onTouchEnd(event);
  }, [touch, pause, prev, next, touchUnpauseTimeout, interval, onTouchEnd]);
  const shouldPlay = interval != null && !paused && !isSliding;
  const intervalHandleRef = (0,react.useRef)();
  (0,react.useEffect)(() => {
    var _ref, _activeChildIntervalR;
    if (!shouldPlay) {
      return undefined;
    }
    const nextFunc = isRTL ? prev : next;
    intervalHandleRef.current = window.setInterval(document.visibilityState ? nextWhenVisible : nextFunc, (_ref = (_activeChildIntervalR = activeChildIntervalRef.current) != null ? _activeChildIntervalR : interval) != null ? _ref : undefined);
    return () => {
      if (intervalHandleRef.current !== null) {
        clearInterval(intervalHandleRef.current);
      }
    };
  }, [shouldPlay, prev, next, activeChildIntervalRef, interval, nextWhenVisible, isRTL]);
  const indicatorOnClicks = (0,react.useMemo)(() => indicators && Array.from({
    length: numChildren
  }, (_, index) => event => {
    onSelect == null || onSelect(index, event);
  }), [indicators, numChildren, onSelect]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Component, {
    ref: elementRef,
    ...props,
    onKeyDown: handleKeyDown,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
    className: classnames_default()(className, prefix, slide && 'slide', fade && `${prefix}-fade`, variant && `${prefix}-${variant}`),
    children: [indicators && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: `${prefix}-indicators`,
      children: (0,ElementChildren/* map */.UI)(children, (_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        type: "button",
        "data-bs-target": "" // Bootstrap requires this in their css.
        ,
        "aria-label": indicatorLabels != null && indicatorLabels.length ? indicatorLabels[index] : `Slide ${index + 1}`,
        className: index === renderedActiveIndex ? 'active' : undefined,
        onClick: indicatorOnClicks ? indicatorOnClicks[index] : undefined,
        "aria-current": index === renderedActiveIndex
      }, index))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: `${prefix}-inner`,
      children: (0,ElementChildren/* map */.UI)(children, (child, index) => {
        const isActive = index === renderedActiveIndex;
        return slide ? /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionWrapper/* default */.Z, {
          in: isActive,
          onEnter: isActive ? handleEnter : undefined,
          onEntered: isActive ? handleEntered : undefined,
          addEndListener: transitionEndListener/* default */.Z,
          children: (status, innerProps) => /*#__PURE__*/react.cloneElement(child, {
            ...innerProps,
            className: classnames_default()(child.props.className, isActive && status !== 'entered' && orderClassName, (status === 'entered' || status === 'exiting') && 'active', (status === 'entering' || status === 'exiting') && directionalClassName)
          })
        }) : ( /*#__PURE__*/react.cloneElement(child, {
          className: classnames_default()(child.props.className, isActive && 'active')
        }));
      })
    }), controls && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [(wrap || activeIndex !== 0) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Anchor/* default */.Z, {
        className: `${prefix}-control-prev`,
        onClick: prev,
        children: [prevIcon, prevLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "visually-hidden",
          children: prevLabel
        })]
      }), (wrap || activeIndex !== numChildren - 1) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Anchor/* default */.Z, {
        className: `${prefix}-control-next`,
        onClick: next,
        children: [nextIcon, nextLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "visually-hidden",
          children: nextLabel
        })]
      })]
    })]
  });
});
Carousel.displayName = 'Carousel';
/* harmony default export */ var esm_Carousel = (Object.assign(Carousel, {
  Caption: esm_CarouselCaption,
  Item: CarouselItem/* default */.Z
}));

/***/ }),

/***/ 91322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
"use client";





const CarouselItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  const finalClassName = classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'carousel-item'));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: finalClassName
  });
});
CarouselItem.displayName = 'CarouselItem';
/* harmony default export */ __webpack_exports__["Z"] = (CarouselItem);

/***/ }),

/***/ 53439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ed": function() { return /* binding */ forEach; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "XW": function() { return /* binding */ hasChildOfType; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */
function map(children, func) {
  let index = 0;
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, child => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) ? func(child, index++) : child);
}

/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */
function forEach(children, func) {
  let index = 0;
  react__WEBPACK_IMPORTED_MODULE_0__.Children.forEach(children, child => {
    if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) func(child, index++);
  });
}

/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */
function hasChildOfType(children, type) {
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children).some(child => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) && child.type === type);
}


/***/ })

}]);